let region = {

  // 按地区获取省
  getProvinces: function (regionID) {
    let provinces = this.getAllProvinces();
    let re = [];
    for (let i = 0; i < provinces.length; i++) {
      if (provinces[i].regionID == regionID)
        re.push(provinces[i]);
    }
    return re;
  },

  // 获取单个省
  getProvince: function (pid) {
    let provinces = this.getAllProvinces();
    for (let i = 0; i < provinces.length; i++) {
      if (provinces[i].provinceID == pid)
        return provinces[i];
    }
    return null;
  },

  // 获取单个省
  getProvinceByPrefix: function (prefix) {
    let citys = this.getAllCitys();
    for (let i = 0; i < citys.length; i++) {
      if (citys[i].prefix == prefix) {
        return this.getProvince(citys[i].provinceID);
      }
    }
    return null;
  },

  // 获取单个省
  getProvinceByTitle: function (title) {
    let list = this.getAllProvinces();
    for (let i = 0; i < list.length; i++) {
      if (list[i].title == title) {
        return list[i];
      }
    }
    return null;
  },

  // 获取某省的市
  getCitys: function (pid) {
    let citys = this.getAllCitys();
    let re = [];
    for (let i = 0; i < citys.length; i++) {
      if (citys[i].provinceID == pid)
        re.push(citys[i]);
    }
    return re;
  },

  // 获取单个市
  getCity: function (cid) {
    let citys = this.getAllCitys();
    for (let i = 0; i < citys.length; i++) {
      if (citys[i].cityID == cid)
        return citys[i];
    }
    return null;
  },

  // 获取单个市
  getCityByTitle: function (title, ptitle) {
    let citys = this.getAllCitys();
    if (ptitle) {
      let p = this.getProvinceByTitle(ptitle);
      citys = this.getCitys(p.provinceID);
    }

    for (let i = 0; i < citys.length; i++) {
      if (citys[i].title == title)
        return citys[i];
    }
    return null;
  },

  getCityByProvinceTitle: function (title) {
    let p = this.getProvinceByTitle(title);
    if (!p) {
      return null;
    }
    return this.getCitys(p.provinceID);
  },

  // 获取所有区域
  getAllArea: function () {
    let areas = [{
      'areaID': 1,
      'title': '上海辖区'
    }, {
      'areaID': 2,
      'title': '广州辖区'
    }, {
      'areaID': 3,
      'title': '北京辖区'
    }];
    return areas;
  },

  // 获取所有地区
  getAllRegions: function () {
    let regions = [{
      'regionID': 0,
      'title': '中国',
      'code': 'CN',
      'prefix': '86'
    }, {
      'regionID': 1,
      'title': '中国香港',
      'code': 'HK',
      'prefix': '852'
    }, {
      'regionID': 2,
      'title': '中国澳门',
      'code': 'OM',
      'prefix': '853'
    }, {
      'regionID': 3,
      'title': '中国台湾',
      'code': 'TW',
      'prefix': '886'
    }, {
      'regionID': 4,
      'code': 'AD',
      'title': '安道尔共和国',
      'prefix': 376
    }, {
      'regionID': 4,
      'code': 'AE',
      'title': '阿拉伯联合酋长国',
      'prefix': 971
    }, {
      'regionID': 4,
      'code': 'AF',
      'title': '阿富汗',
      'prefix': 93
    }, {
      'regionID': 4,
      'code': 'AG',
      'title': '安提瓜和巴布达',
      'prefix': 86 //1268
    }, {
      'regionID': 4,
      'code': 'AI',
      'title': '安圭拉岛',
      'prefix': 86 //1264
    }, {
      'regionID': 4,
      'code': 'AL',
      'title': '阿尔巴尼亚',
      'prefix': 355
    }, {
      'regionID': 4,
      'code': 'AM',
      'title': '亚美尼亚',
      'prefix': 374
    }, {
      'regionID': 4,
      'code': 'AO',
      'title': '安哥拉',
      'prefix': 244
    }, {
      'regionID': 4,
      'code': 'AR',
      'title': '阿根廷',
      'prefix': 54
    }, {
      'regionID': 4,
      'code': 'AT',
      'title': '奥地利',
      'prefix': 43
    }, {
      'regionID': 4,
      'code': 'AU',
      'title': '澳大利亚',
      'prefix': 61
    }, {
      'regionID': 4,
      'code': 'AZ',
      'title': '阿塞拜疆',
      'prefix': 994
    }, {
      'regionID': 4,
      'code': 'BB',
      'title': '巴巴多斯',
      'prefix': 86 //1246
    }, {
      'regionID': 4,
      'code': 'BD',
      'title': '孟加拉国',
      'prefix': 880
    }, {
      'regionID': 4,
      'code': 'BE',
      'title': '比利时',
      'prefix': 32
    }, {
      'regionID': 4,
      'code': 'BF',
      'title': '布基纳法索',
      'prefix': 226
    }, {
      'regionID': 4,
      'code': 'BG',
      'title': '保加利亚',
      'prefix': 359
    }, {
      'regionID': 4,
      'code': 'BH',
      'title': '巴林',
      'prefix': 973
    }, {
      'regionID': 4,
      'code': 'BI',
      'title': '布隆迪',
      'prefix': 257
    }, {
      'regionID': 4,
      'code': 'BJ',
      'title': '贝宁',
      'prefix': 229
    }, {
      'regionID': 4,
      'code': 'BL',
      'title': '巴勒斯坦',
      'prefix': 970
    }, {
      'regionID': 4,
      'code': 'BM',
      'title': '百慕大群岛',
      'prefix': 86 //1441
    }, {
      'regionID': 4,
      'code': 'BN',
      'title': '文莱',
      'prefix': 673
    }, {
      'regionID': 4,
      'code': 'BO',
      'title': '玻利维亚',
      'prefix': 591
    }, {
      'regionID': 4,
      'code': 'BR',
      'title': '巴西',
      'prefix': 55
    }, {
      'regionID': 4,
      'code': 'BS',
      'title': '巴哈马',
      'prefix': 86 //1242
    }, {
      'regionID': 4,
      'code': 'BW',
      'title': '博茨瓦纳',
      'prefix': 267
    }, {
      'regionID': 4,
      'code': 'BY',
      'title': '白俄罗斯',
      'prefix': 375
    }, {
      'regionID': 4,
      'code': 'BZ',
      'title': '伯利兹',
      'prefix': 501
    }, {
      'regionID': 4,
      'code': 'CA',
      'title': '加拿大',
      'prefix': 1
    }, {
      'regionID': 4,
      'code': 'KY',
      'title': '开曼群岛',
      'prefix': 86 //1345
    }, {
      'regionID': 4,
      'code': 'CF',
      'title': '中非共和国',
      'prefix': 236
    }, {
      'regionID': 4,
      'code': 'CG',
      'title': '刚果',
      'prefix': 242
    }, {
      'regionID': 4,
      'code': 'CH',
      'title': '瑞士',
      'prefix': 41
    }, {
      'regionID': 4,
      'code': 'CK',
      'title': '库克群岛',
      'prefix': 682
    }, {
      'regionID': 4,
      'code': 'CL',
      'title': '智利',
      'prefix': 56
    }, {
      'regionID': 4,
      'code': 'CM',
      'title': '喀麦隆',
      'prefix': 237
    }, {
      'regionID': 4,
      'code': 'CO',
      'title': '哥伦比亚',
      'prefix': 57
    }, {
      'regionID': 4,
      'code': 'CR',
      'title': '哥斯达黎加',
      'prefix': 506
    }, {
      'regionID': 4,
      'code': 'CS',
      'title': '捷克',
      'prefix': 420
    }, {
      'regionID': 4,
      'code': 'CU',
      'title': '古巴',
      'prefix': 53
    }, {
      'regionID': 4,
      'code': 'CY',
      'title': '塞浦路斯',
      'prefix': 357
    }, {
      'regionID': 4,
      'code': 'CZ',
      'title': '捷克',
      'prefix': 420
    }, {
      'regionID': 4,
      'code': 'DE',
      'title': '德国',
      'prefix': 49
    }, {
      'regionID': 4,
      'code': 'DJ',
      'title': '吉布提',
      'prefix': 253
    }, {
      'regionID': 4,
      'code': 'DK',
      'title': '丹麦',
      'prefix': 45
    }, {
      'regionID': 4,
      'code': 'DO',
      'title': '多米尼加共和国',
      'prefix': 86 //1890
    }, {
      'regionID': 4,
      'code': 'DZ',
      'title': '阿尔及利亚',
      'prefix': 213
    }, {
      'regionID': 4,
      'code': 'EC',
      'title': '厄瓜多尔',
      'prefix': 593
    }, {
      'regionID': 4,
      'code': 'EE',
      'title': '爱沙尼亚',
      'prefix': 372
    }, {
      'regionID': 4,
      'code': 'EG',
      'title': '埃及',
      'prefix': 20
    }, {
      'regionID': 4,
      'code': 'ES',
      'title': '西班牙',
      'prefix': 34
    }, {
      'regionID': 4,
      'code': 'ET',
      'title': '埃塞俄比亚',
      'prefix': 251
    }, {
      'regionID': 4,
      'code': 'FI',
      'title': '芬兰',
      'prefix': 358
    }, {
      'regionID': 4,
      'code': 'FJ',
      'title': '斐济',
      'prefix': 679
    }, {
      'regionID': 4,
      'code': 'FR',
      'title': '法国',
      'prefix': 33
    }, {
      'regionID': 4,
      'code': 'GA',
      'title': '加蓬',
      'prefix': 241
    }, {
      'regionID': 4,
      'code': 'GB',
      'title': '英国',
      'prefix': 44
    }, {
      'regionID': 4,
      'code': 'GD',
      'title': '格林纳达',
      'prefix': 86 //1809
    }, {
      'regionID': 4,
      'code': 'GE',
      'title': '格鲁吉亚',
      'prefix': 995
    }, {
      'regionID': 4,
      'code': 'GF',
      'title': '法属圭亚那',
      'prefix': 594
    }, {
      'regionID': 4,
      'code': 'GH',
      'title': '加纳',
      'prefix': 233
    }, {
      'regionID': 4,
      'code': 'GI',
      'title': '直布罗陀',
      'prefix': 350
    }, {
      'regionID': 4,
      'code': 'GM',
      'title': '冈比亚',
      'prefix': 220
    }, {
      'regionID': 4,
      'code': 'GN',
      'title': '几内亚',
      'prefix': 224
    }, {
      'regionID': 4,
      'code': 'GR',
      'title': '希腊',
      'prefix': 30
    }, {
      'regionID': 4,
      'code': 'GT',
      'title': '危地马拉',
      'prefix': 502
    }, {
      'regionID': 4,
      'code': 'GU',
      'title': '关岛',
      'prefix': 86 //1671
    }, {
      'regionID': 4,
      'code': 'GY',
      'title': '圭亚那',
      'prefix': 592
    }, {
      'regionID': 4,
      'code': 'HN',
      'title': '洪都拉斯',
      'prefix': 504
    }, {
      'regionID': 4,
      'code': 'HT',
      'title': '海地',
      'prefix': 509
    }, {
      'regionID': 4,
      'code': 'HU',
      'title': '匈牙利',
      'prefix': 36
    }, {
      'regionID': 4,
      'code': 'ID',
      'title': '印度尼西亚',
      'prefix': 62
    }, {
      'regionID': 4,
      'code': 'IE',
      'title': '爱尔兰',
      'prefix': 353
    }, {
      'regionID': 4,
      'code': 'IL',
      'title': '以色列',
      'prefix': 972
    }, {
      'regionID': 4,
      'code': 'IN',
      'title': '印度',
      'prefix': 91
    }, {
      'regionID': 4,
      'code': 'IQ',
      'title': '伊拉克',
      'prefix': 964
    }, {
      'regionID': 4,
      'code': 'IR',
      'title': '伊朗',
      'prefix': 98
    }, {
      'regionID': 4,
      'code': 'IS',
      'title': '冰岛',
      'prefix': 354
    }, {
      'regionID': 4,
      'code': 'IT',
      'title': '意大利',
      'prefix': 39
    }, {
      'regionID': 4,
      'code': 'CI',
      'title': '科特迪瓦',
      'prefix': 225
    }, {
      'regionID': 4,
      'code': 'JM',
      'title': '牙买加',
      'prefix': 86 //1876
    }, {
      'regionID': 4,
      'code': 'JO',
      'title': '约旦',
      'prefix': 962
    }, {
      'regionID': 4,
      'code': 'JP',
      'title': '日本',
      'prefix': 81
    }, {
      'regionID': 4,
      'code': 'KE',
      'title': '肯尼亚',
      'prefix': 254
    }, {
      'regionID': 4,
      'code': 'KG',
      'title': '吉尔吉斯坦',
      'prefix': 331
    }, {
      'regionID': 4,
      'code': 'KH',
      'title': '柬埔寨',
      'prefix': 855
    }, {
      'regionID': 4,
      'code': 'KP',
      'title': '朝鲜',
      'prefix': 850
    }, {
      'regionID': 4,
      'code': 'KR',
      'title': '韩国',
      'prefix': 82
    }, {
      'regionID': 4,
      'code': 'KW',
      'title': '科威特',
      'prefix': 965
    }, {
      'regionID': 4,
      'code': 'KZ',
      'title': '哈萨克斯坦',
      'prefix': 327
    }, {
      'regionID': 4,
      'code': 'LA',
      'title': '老挝',
      'prefix': 856
    }, {
      'regionID': 4,
      'code': 'LB',
      'title': '黎巴嫩',
      'prefix': 961
    }, {
      'regionID': 4,
      'code': 'LC',
      'title': '圣卢西亚',
      'prefix': 86 //1758
    }, {
      'regionID': 4,
      'code': 'LI',
      'title': '列支敦士登',
      'prefix': 423
    }, {
      'regionID': 4,
      'code': 'LK',
      'title': '斯里兰卡',
      'prefix': 94
    }, {
      'regionID': 4,
      'code': 'LR',
      'title': '利比里亚',
      'prefix': 231
    }, {
      'regionID': 4,
      'code': 'LS',
      'title': '莱索托',
      'prefix': 266
    }, {
      'regionID': 4,
      'code': 'LT',
      'title': '立陶宛',
      'prefix': 370
    }, {
      'regionID': 4,
      'code': 'LU',
      'title': '卢森堡',
      'prefix': 352
    }, {
      'regionID': 4,
      'code': 'LV',
      'title': '拉脱维亚',
      'prefix': 371
    }, {
      'regionID': 4,
      'code': 'LY',
      'title': '利比亚',
      'prefix': 218
    }, {
      'regionID': 4,
      'code': 'MA',
      'title': '摩洛哥',
      'prefix': 212
    }, {
      'regionID': 4,
      'code': 'MC',
      'title': '摩纳哥',
      'prefix': 377
    }, {
      'regionID': 4,
      'code': 'MD',
      'title': '摩尔多瓦',
      'prefix': 373
    }, {
      'regionID': 4,
      'code': 'MG',
      'title': '马达加斯加',
      'prefix': 261
    }, {
      'regionID': 4,
      'code': 'ML',
      'title': '马里',
      'prefix': 223
    }, {
      'regionID': 4,
      'code': 'MM',
      'title': '缅甸',
      'prefix': 95
    }, {
      'regionID': 4,
      'code': 'MN',
      'title': '蒙古',
      'prefix': 976
    }, {
      'regionID': 4,
      'code': 'MS',
      'title': '蒙特塞拉特岛',
      'prefix': 86 //1664
    }, {
      'regionID': 4,
      'code': 'MT',
      'title': '马耳他',
      'prefix': 356
    }, {
      'regionID': 4,
      'code': 'MU',
      'title': '毛里求斯',
      'prefix': 230
    }, {
      'regionID': 4,
      'code': 'MV',
      'title': '马尔代夫',
      'prefix': 960
    }, {
      'regionID': 4,
      'code': 'MW',
      'title': '马拉维',
      'prefix': 265
    }, {
      'regionID': 4,
      'code': 'MX',
      'title': '墨西哥',
      'prefix': 52
    }, {
      'regionID': 4,
      'code': 'MY',
      'title': '马来西亚',
      'prefix': 60
    }, {
      'regionID': 4,
      'code': 'MZ',
      'title': '莫桑比克',
      'prefix': 258
    }, {
      'regionID': 4,
      'code': 'NA',
      'title': '纳米比亚',
      'prefix': 264
    }, {
      'regionID': 4,
      'code': 'NE',
      'title': '尼日尔',
      'prefix': 977
    }, {
      'regionID': 4,
      'code': 'NG',
      'title': '尼日利亚',
      'prefix': 234
    }, {
      'regionID': 4,
      'code': 'NI',
      'title': '尼加拉瓜',
      'prefix': 505
    }, {
      'regionID': 4,
      'code': 'NL',
      'title': '荷兰',
      'prefix': 31
    }, {
      'regionID': 4,
      'code': 'NO',
      'title': '挪威',
      'prefix': 47
    }, {
      'regionID': 4,
      'code': 'NP',
      'title': '尼泊尔',
      'prefix': 977
    }, {
      'regionID': 4,
      'code': 'NR',
      'title': '瑙鲁',
      'prefix': 674
    }, {
      'regionID': 4,
      'code': 'NZ',
      'title': '新西兰',
      'prefix': 64
    }, {
      'regionID': 4,
      'code': 'OM',
      'title': '阿曼',
      'prefix': 968
    }, {
      'regionID': 4,
      'code': 'PA',
      'title': '巴拿马',
      'prefix': 507
    }, {
      'regionID': 4,
      'code': 'PE',
      'title': '秘鲁',
      'prefix': 51
    }, {
      'regionID': 4,
      'code': 'PF',
      'title': '法属玻利尼西亚',
      'prefix': 689
    }, {
      'regionID': 4,
      'code': 'PG',
      'title': '巴布亚新几内亚',
      'prefix': 675
    }, {
      'regionID': 4,
      'code': 'PH',
      'title': '菲律宾',
      'prefix': 63
    }, {
      'regionID': 4,
      'code': 'PK',
      'title': '巴基斯坦',
      'prefix': 92
    }, {
      'regionID': 4,
      'code': 'PL',
      'title': '波兰',
      'prefix': 48
    }, {
      'regionID': 4,
      'code': 'PR',
      'title': '波多黎各',
      'prefix': 86 //1787
    }, {
      'regionID': 4,
      'code': 'PT',
      'title': '葡萄牙',
      'prefix': 351
    }, {
      'regionID': 4,
      'code': 'PY',
      'title': '巴拉圭',
      'prefix': 595
    }, {
      'regionID': 4,
      'code': 'QA',
      'title': '卡塔尔',
      'prefix': 974
    }, {
      'regionID': 4,
      'code': 'RO',
      'title': '罗马尼亚',
      'prefix': 40
    }, {
      'regionID': 4,
      'code': 'RU',
      'title': '俄罗斯',
      'prefix': 7
    }, {
      'regionID': 4,
      'code': 'SA',
      'title': '沙特阿拉伯',
      'prefix': 966
    }, {
      'regionID': 4,
      'code': 'SB',
      'title': '所罗门群岛',
      'prefix': 677
    }, {
      'regionID': 4,
      'code': 'SC',
      'title': '塞舌尔',
      'prefix': 248
    }, {
      'regionID': 4,
      'code': 'SD',
      'title': '苏丹',
      'prefix': 249
    }, {
      'regionID': 4,
      'code': 'SE',
      'title': '瑞典',
      'prefix': 46
    }, {
      'regionID': 4,
      'code': 'SG',
      'title': '新加坡',
      'prefix': 65
    }, {
      'regionID': 4,
      'code': 'SI',
      'title': '斯洛文尼亚',
      'prefix': 386
    }, {
      'regionID': 4,
      'code': 'SK',
      'title': '斯洛伐克',
      'prefix': 421
    }, {
      'regionID': 4,
      'code': 'SL',
      'title': '塞拉利昂',
      'prefix': 232
    }, {
      'regionID': 4,
      'code': 'SM',
      'title': '圣马力诺',
      'prefix': 378
    }, {
      'regionID': 4,
      'code': 'SN',
      'title': '塞内加尔',
      'prefix': 221
    }, {
      'regionID': 4,
      'code': 'SO',
      'title': '索马里',
      'prefix': 252
    }, {
      'regionID': 4,
      'code': 'SR',
      'title': '苏里南',
      'prefix': 597
    }, {
      'regionID': 4,
      'code': 'ST',
      'title': '圣多美和普林西比',
      'prefix': 239
    }, {
      'regionID': 4,
      'code': 'SV',
      'title': '萨尔瓦多',
      'prefix': 503
    }, {
      'regionID': 4,
      'code': 'SY',
      'title': '叙利亚',
      'prefix': 963
    }, {
      'regionID': 4,
      'code': 'SZ',
      'title': '斯威士兰',
      'prefix': 268
    }, {
      'regionID': 4,
      'code': 'TD',
      'title': '乍得',
      'prefix': 235
    }, {
      'regionID': 4,
      'code': 'TG',
      'title': '多哥',
      'prefix': 228
    }, {
      'regionID': 4,
      'code': 'TH',
      'title': '泰国',
      'prefix': 66
    }, {
      'regionID': 4,
      'code': 'TJ',
      'title': '塔吉克斯坦',
      'prefix': 992
    }, {
      'regionID': 4,
      'code': 'TM',
      'title': '土库曼斯坦',
      'prefix': 993
    }, {
      'regionID': 4,
      'code': 'TN',
      'title': '突尼斯',
      'prefix': 216
    }, {
      'regionID': 4,
      'code': 'TO',
      'title': '汤加',
      'prefix': 676
    }, {
      'regionID': 4,
      'code': 'TR',
      'title': '土耳其',
      'prefix': 90
    }, {
      'regionID': 4,
      'code': 'TT',
      'title': '特立尼达和多巴哥',
      'prefix': 86 //1809
    }, {
      'regionID': 4,
      'code': 'TZ',
      'title': '坦桑尼亚',
      'prefix': 255
    }, {
      'regionID': 4,
      'code': 'UA',
      'title': '乌克兰',
      'prefix': 380
    }, {
      'regionID': 4,
      'code': 'UG',
      'title': '乌干达',
      'prefix': 256
    }, {
      'regionID': 4,
      'code': 'US',
      'title': '美国',
      'prefix': 1
    }, {
      'regionID': 4,
      'code': 'UY',
      'title': '乌拉圭',
      'prefix': 598
    }, {
      'regionID': 4,
      'code': 'UZ',
      'title': '乌兹别克斯坦',
      'prefix': 233
    }, {
      'regionID': 4,
      'code': 'VC',
      'title': '圣文森特岛',
      'prefix': 86 //1784
    }, {
      'regionID': 4,
      'code': 'VE',
      'title': '委内瑞拉',
      'prefix': 58
    }, {
      'regionID': 4,
      'code': 'VN',
      'title': '越南',
      'prefix': 84
    }, {
      'regionID': 4,
      'code': 'YE',
      'title': '也门',
      'prefix': 967
    }, {
      'regionID': 4,
      'code': 'YU',
      'title': '南斯拉夫',
      'prefix': 381
    }, {
      'regionID': 4,
      'code': 'ZA',
      'title': '南非',
      'prefix': 27
    }, {
      'regionID': 4,
      'code': 'ZM',
      'title': '赞比亚',
      'prefix': 260
    }, {
      'regionID': 4,
      'code': 'ZR',
      'title': '扎伊尔',
      'prefix': 243
    }, {
      'regionID': 4,
      'code': 'ZW',
      'title': '津巴布韦',
      'prefix': 263
    }];
    return regions;
  },

  getRegion: function (rid) {
    let list = this.getAllRegions();
    for (let i = 0; i < list.length; i++) {
      if (list[i].regionID == rid)
        return list[i];
    }
    return null;
  },

  getRegionByCode: function (code) {
    let list = this.getAllRegions();
    for (let i = 0; i < list.length; i++) {
      if (list[i].code == code)
        return list[i];
    }
    return null;
  },
  getRegionByTitle: function (title) {
    let list = this.getAllRegions();
    for (let i = 0; i < list.length; i++) {
      if (list[i].title == title)
        return list[i];
    }
    return null;
  },
  getRegionByID: function (regionID) {
    let list = this.getAllRegions();
    for (let i = 0; i < list.length; i++) {
      if (list[i].regionID == regionID)
        return list[i];
    }
    return null;
  },
  // 获取所有的省
  getAllProvinces: function () {
    let provinces = [{
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 1,
      'title': '北京',
      'areaID': 3,
      'pinYin': 'bei jing'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 2,
      'title': '上海',
      'areaID': 1,
      'pinYin': 'shang hai'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 3,
      'title': '天津',
      'areaID': 3,
      'pinYin': 'tian jin'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 4,
      'title': '重庆',
      'areaID': 3,
      'pinYin': 'zhong qing'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 5,
      'title': '内蒙古',
      'areaID': 3,
      'pinYin': 'nei meng gu'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 6,
      'title': '山西',
      'areaID': 3,
      'pinYin': 'shan xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 7,
      'title': '河北',
      'areaID': 3,
      'pinYin': 'he bei'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 8,
      'title': '辽宁',
      'areaID': 3,
      'pinYin': 'liao ning'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 9,
      'title': '吉林',
      'areaID': 3,
      'pinYin': 'ji lin'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 10,
      'title': '黑龙江',
      'areaID': 3,
      'pinYin': 'hei long jiang'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 11,
      'title': '江苏',
      'areaID': 1,
      'pinYin': 'jiang su'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 12,
      'title': '安徽',
      'areaID': 3,
      'pinYin': 'an hui'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 13,
      'title': '山东',
      'areaID': 3,
      'pinYin': 'shan dong'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 14,
      'title': '浙江',
      'areaID': 1,
      'pinYin': 'zhe jiang'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 15,
      'title': '江西',
      'areaID': 3,
      'pinYin': 'jiang xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 16,
      'title': '福建',
      'areaID': 2,
      'pinYin': 'fu jian'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 17,
      'title': '湖南',
      'areaID': 2,
      'pinYin': 'hu nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 18,
      'title': '湖北',
      'areaID': 3,
      'pinYin': 'hu bei'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 19,
      'title': '河南',
      'areaID': 3,
      'pinYin': 'he nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 20,
      'title': '广东',
      'areaID': 2,
      'pinYin': 'guang dong'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 21,
      'title': '海南',
      'areaID': 2,
      'pinYin': 'hai nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 22,
      'title': '广西',
      'areaID': 2,
      'pinYin': 'guang xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 23,
      'title': '贵州',
      'areaID': 3,
      'pinYin': 'gui zhou'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 24,
      'title': '四川',
      'areaID': 3,
      'pinYin': 'si chuan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 25,
      'title': '云南',
      'areaID': 3,
      'pinYin': 'yun nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 26,
      'title': '陕西',
      'areaID': 3,
      'pinYin': 'shaan xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 27,
      'title': '甘肃',
      'areaID': 3,
      'pinYin': 'gan su'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 28,
      'title': '宁夏',
      'areaID': 3,
      'pinYin': 'ning xia'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 29,
      'title': '青海',
      'areaID': 3,
      'pinYin': 'qing hai'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 30,
      'title': '新疆',
      'areaID': 3,
      'pinYin': 'xin jiang'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 31,
      'title': '西藏',
      'areaID': 3,
      'pinYin': 'xi cang'
    }, {
      'region': '香港地区',
      'regionID': 1,
      'prefix': '',
      'provinceID': 32,
      'title': '香港',
      'areaID': 2,
      'pinYin': 'xiang gang'
    }, {
      'region': '澳门地区',
      'regionID': 2,
      'prefix': '',
      'provinceID': 33,
      'title': '澳门',
      'areaID': 2,
      'pinYin': 'ao men'
    }, {
      'region': '台湾地区',
      'regionID': 3,
      'prefix': '',
      'provinceID': 34,
      'title': '台湾',
      'areaID': 2,
      'pinYin': 'tai wan'
    }];
    return provinces;
  },

  // 获取所有的市
  getAllCitys: function () {
    let citys = [{
      'provinceID': 1,
      'cityID': 1,
      'title': '北京市',
      'prefix': '010',
      'pinYin': 'bei jing shi'
    }, {
      'provinceID': 2,
      'cityID': 19,
      'title': '上海市',
      'prefix': '021',
      'pinYin': 'shang hai shi'
    }, {
      'provinceID': 3,
      'cityID': 40,
      'title': '天津市',
      'prefix': '022',
      'pinYin': 'tian jin shi'
    }, {
      'provinceID': 4,
      'cityID': 58,
      'title': '重庆市',
      'prefix': '023',
      'pinYin': 'zhong qing shi'
    }, {
      'provinceID': 5,
      'cityID': 99,
      'title': '呼和浩特市',
      'prefix': '0471',
      'pinYin': 'hu he hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 100,
      'title': '包头市',
      'prefix': '0472',
      'pinYin': 'bao tou shi'
    }, {
      'provinceID': 5,
      'cityID': 101,
      'title': '乌海市',
      'prefix': '0473',
      'pinYin': 'wu hai shi'
    }, {
      'provinceID': 5,
      'cityID': 102,
      'title': '赤峰市',
      'prefix': '0476',
      'pinYin': 'chi feng shi'
    }, {
      'provinceID': 5,
      'cityID': 111,
      'title': '通辽市',
      'prefix': '0475',
      'pinYin': 'tong liao shi'
    }, {
      'provinceID': 5,
      'cityID': 2626,
      'title': '鄂尔多斯市',
      'prefix': '0477',
      'pinYin': 'e er duo si shi'
    }, {
      'provinceID': 5,
      'cityID': 2627,
      'title': '呼伦贝尔市',
      'prefix': '0470',
      'pinYin': 'hu lun bei er shi'
    }, {
      'provinceID': 5,
      'cityID': 2628,
      'title': '巴彦淖尔市',
      'prefix': '0478',
      'pinYin': 'ba yan nao er shi'
    }, {
      'provinceID': 5,
      'cityID': 2629,
      'title': '乌兰察布市',
      'prefix': '0474',
      'pinYin': 'wu lan cha bu shi'
    }, {
      'provinceID': 5,
      'cityID': 2630,
      'title': '兴安盟',
      'prefix': '0482',
      'pinYin': 'xing an meng'
    }, {
      'provinceID': 5,
      'cityID': 2631,
      'title': '锡林郭勒盟',
      'prefix': '0479',
      'pinYin': 'xi lin guo le meng'
    }, {
      'provinceID': 5,
      'cityID': 2632,
      'title': '阿拉善盟',
      'prefix': '0483',
      'pinYin': 'a la shan meng'
    }, {
      'provinceID': 5,
      'cityID': 104,
      'title': '丰镇市',
      'prefix': '0474',
      'pinYin': 'feng zhen shi'
    }, {
      'provinceID': 5,
      'cityID': 105,
      'title': '锡林浩特市',
      'prefix': '0479',
      'pinYin': 'xi lin hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 106,
      'title': '二连浩特市',
      'prefix': '0479',
      'pinYin': 'er lian hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 108,
      'title': '满州里市',
      'prefix': '0470',
      'pinYin': 'man zhou li shi'
    }, {
      'provinceID': 5,
      'cityID': 109,
      'title': '牙克石市',
      'prefix': '0470',
      'pinYin': 'ya ke shi shi'
    }, {
      'provinceID': 5,
      'cityID': 110,
      'title': '扎兰屯市',
      'prefix': '0470',
      'pinYin': 'zha lan tun shi'
    }, {
      'provinceID': 5,
      'cityID': 112,
      'title': '霍林郭勒市',
      'prefix': '0475',
      'pinYin': 'huo lin guo le shi'
    }, {
      'provinceID': 5,
      'cityID': 2346,
      'title': '乌兰浩特市',
      'prefix': '0482',
      'pinYin': 'wu lan hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 2633,
      'title': '根河市',
      'prefix': '0470',
      'pinYin': 'gen he shi'
    }, {
      'provinceID': 5,
      'cityID': 2634,
      'title': '额尔古纳市',
      'prefix': '0470',
      'pinYin': 'e er gu na shi'
    }, {
      'provinceID': 5,
      'cityID': 2635,
      'title': '阿尔山市',
      'prefix': '0482',
      'pinYin': 'a er shan shi'
    }, {
      'provinceID': 6,
      'cityID': 180,
      'title': '太原市',
      'prefix': '0351',
      'pinYin': 'tai yuan shi'
    }, {
      'provinceID': 6,
      'cityID': 18,
      'title': '大同市',
      'prefix': '0352',
      'pinYin': 'da tong shi'
    }, {
      'provinceID': 6,
      'cityID': 182,
      'title': '阳泉市',
      'prefix': '0353',
      'pinYin': 'yang quan shi'
    }, {
      'provinceID': 6,
      'cityID': 183,
      'title': '长治市',
      'prefix': '0355',
      'pinYin': 'chang zhi shi'
    }, {
      'provinceID': 6,
      'cityID': 184,
      'title': '晋城市',
      'prefix': '0356',
      'pinYin': 'jin cheng shi'
    }, {
      'provinceID': 6,
      'cityID': 185,
      'title': '朔州市',
      'prefix': '0349',
      'pinYin': 'shuo zhou shi'
    }, {
      'provinceID': 6,
      'cityID': 187,
      'title': '忻州市',
      'prefix': '0350',
      'pinYin': 'xin zhou shi'
    }, {
      'provinceID': 6,
      'cityID': 189,
      'title': '临汾市',
      'prefix': '0357',
      'pinYin': 'lin fen shi'
    }, {
      'provinceID': 6,
      'cityID': 192,
      'title': '运城市',
      'prefix': '0359',
      'pinYin': 'yun cheng shi'
    }, {
      'provinceID': 6,
      'cityID': 2601,
      'title': '晋中市',
      'prefix': '0354',
      'pinYin': 'jin zhong shi'
    }, {
      'provinceID': 6,
      'cityID': 186,
      'title': '古交市',
      'prefix': '0351',
      'pinYin': 'gu jiao shi'
    }, {
      'provinceID': 6,
      'cityID': 191,
      'title': '霍州市',
      'prefix': '0357',
      'pinYin': 'huo zhou shi'
    }, {
      'provinceID': 6,
      'cityID': 205,
      'title': '潞城市',
      'prefix': '0355',
      'pinYin': 'lu cheng shi'
    }, {
      'provinceID': 6,
      'cityID': 209,
      'title': '高平市',
      'prefix': '0356',
      'pinYin': 'gao ping shi'
    }, {
      'provinceID': 6,
      'cityID': 228,
      'title': '原平市',
      'prefix': '0350',
      'pinYin': 'yuan ping shi'
    }, {
      'provinceID': 6,
      'cityID': 242,
      'title': '介休市',
      'prefix': '0354',
      'pinYin': 'jie xiu shi'
    }, {
      'provinceID': 6,
      'cityID': 251,
      'title': '汾阳市',
      'prefix': '0358',
      'pinYin': 'fen yang shi'
    }, {
      'provinceID': 6,
      'cityID': 254,
      'title': '孝义市',
      'prefix': '0358',
      'pinYin': 'xiao yi shi'
    }, {
      'provinceID': 6,
      'cityID': 276,
      'title': '河津市',
      'prefix': '0359',
      'pinYin': 'he jin shi'
    }, {
      'provinceID': 6,
      'cityID': 277,
      'title': '永济市',
      'prefix': '0359',
      'pinYin': 'yong ji shi'
    }, {
      'provinceID': 6,
      'cityID': 2314,
      'title': '侯马市',
      'prefix': '0357',
      'pinYin': 'hou ma shi'
    }, {
      'provinceID': 6,
      'cityID': 2643,
      'title': '吕梁市',
      'prefix': '0358',
      'pinYin': 'lv liang shi'
    }, {
      'provinceID': 7,
      'cityID': 284,
      'title': '石家庄市',
      'prefix': '0311',
      'pinYin': 'shi jia zhuang shi'
    }, {
      'provinceID': 7,
      'cityID': 285,
      'title': '邯郸市',
      'prefix': '0310',
      'pinYin': 'han dan shi'
    }, {
      'provinceID': 7,
      'cityID': 286,
      'title': '邢台市',
      'prefix': '0319',
      'pinYin': 'xing tai shi'
    }, {
      'provinceID': 7,
      'cityID': 287,
      'title': '保定市',
      'prefix': '0312',
      'pinYin': 'bao ding shi'
    }, {
      'provinceID': 7,
      'cityID': 288,
      'title': '张家口市',
      'prefix': '0313',
      'pinYin': 'zhang jia kou shi'
    }, {
      'provinceID': 7,
      'cityID': 289,
      'title': '承德市',
      'prefix': '0314',
      'pinYin': 'cheng de shi'
    }, {
      'provinceID': 7,
      'cityID': 290,
      'title': '唐山市',
      'prefix': '0315',
      'pinYin': 'tang shan shi'
    }, {
      'provinceID': 7,
      'cityID': 291,
      'title': '秦皇岛市',
      'prefix': '0335',
      'pinYin': 'qin huang dao shi'
    }, {
      'provinceID': 7,
      'cityID': 292,
      'title': '沧州市',
      'prefix': '0317',
      'pinYin': 'cang zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 293,
      'title': '廊坊市',
      'prefix': '0316',
      'pinYin': 'lang fang shi'
    }, {
      'provinceID': 7,
      'cityID': 300,
      'title': '衡水市',
      'prefix': '0318',
      'pinYin': 'heng shui shi'
    }, {
      'provinceID': 7,
      'cityID': 294,
      'title': '武安市',
      'prefix': '0310',
      'pinYin': 'wu an shi'
    }, {
      'provinceID': 7,
      'cityID': 295,
      'title': '霸州市',
      'prefix': '0316',
      'pinYin': 'ba zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 296,
      'title': '泊头市',
      'prefix': '0317',
      'pinYin': 'bo tou shi'
    }, {
      'provinceID': 7,
      'cityID': 297,
      'title': '任丘市',
      'prefix': '0317',
      'pinYin': 'ren qiu shi'
    }, {
      'provinceID': 7,
      'cityID': 298,
      'title': '黄骅市',
      'prefix': '0317',
      'pinYin': 'huang  shi'
    }, {
      'provinceID': 7,
      'cityID': 299,
      'title': '河间市',
      'prefix': '0317',
      'pinYin': 'he jian shi'
    }, {
      'provinceID': 7,
      'cityID': 312,
      'title': '迁安市',
      'prefix': '0315',
      'pinYin': 'qian an shi'
    }, {
      'provinceID': 7,
      'cityID': 317,
      'title': '遵化市',
      'prefix': '0315',
      'pinYin': 'zun hua shi'
    }, {
      'provinceID': 7,
      'cityID': 327,
      'title': '三河市',
      'prefix': '0316',
      'pinYin': 'san he shi'
    }, {
      'provinceID': 7,
      'cityID': 2234,
      'title': '定州市',
      'prefix': '0312',
      'pinYin': 'ding zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2235,
      'title': '安国市',
      'prefix': '0312',
      'pinYin': 'an guo shi'
    }, {
      'provinceID': 7,
      'cityID': 2240,
      'title': '涿州市',
      'prefix': '0312',
      'pinYin': 'zhuo zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2241,
      'title': '高碑店市',
      'prefix': '0312',
      'pinYin': 'gao bei dian shi'
    }, {
      'provinceID': 7,
      'cityID': 2253,
      'title': '辛集市',
      'prefix': '0311',
      'pinYin': 'xin ji shi'
    }, {
      'provinceID': 7,
      'cityID': 2254,
      'title': '晋州市',
      'prefix': '0311',
      'pinYin': 'jin zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2255,
      'title': '藁城市',
      'prefix': '0311',
      'pinYin': 'gao cheng shi'
    }, {
      'provinceID': 7,
      'cityID': 2256,
      'title': '新乐市',
      'prefix': '0311',
      'pinYin': 'xin le shi'
    }, {
      'provinceID': 7,
      'cityID': 2257,
      'title': '鹿泉市',
      'prefix': '0311',
      'pinYin': 'lu quan shi'
    }, {
      'provinceID': 7,
      'cityID': 2268,
      'title': '沙河市',
      'prefix': '0319',
      'pinYin': 'sha he shi'
    }, {
      'provinceID': 7,
      'cityID': 2271,
      'title': '南宫市',
      'prefix': '0319',
      'pinYin': 'nan gong shi'
    }, {
      'provinceID': 7,
      'cityID': 2277,
      'title': '冀州市',
      'prefix': '0318',
      'pinYin': 'ji zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2278,
      'title': '深州市',
      'prefix': '0318',
      'pinYin': 'shen zhou shi'
    }, {
      'provinceID': 8,
      'cityID': 352,
      'title': '沈阳市',
      'prefix': '024',
      'pinYin': 'shen yang shi'
    }, {
      'provinceID': 8,
      'cityID': 353,
      'title': '大连市',
      'prefix': '0411',
      'pinYin': 'da lian shi'
    }, {
      'provinceID': 8,
      'cityID': 354,
      'title': '鞍山市',
      'prefix': '0412',
      'pinYin': 'an shan shi'
    }, {
      'provinceID': 8,
      'cityID': 355,
      'title': '抚顺市',
      'prefix': '0413',
      'pinYin': 'fu shun shi'
    }, {
      'provinceID': 8,
      'cityID': 356,
      'title': '本溪市',
      'prefix': '0414',
      'pinYin': 'ben xi shi'
    }, {
      'provinceID': 8,
      'cityID': 357,
      'title': '丹东市',
      'prefix': '0415',
      'pinYin': 'dan dong shi'
    }, {
      'provinceID': 8,
      'cityID': 358,
      'title': '锦州市',
      'prefix': '0416',
      'pinYin': 'jin zhou shi'
    }, {
      'provinceID': 8,
      'cityID': 359,
      'title': '葫芦岛市',
      'prefix': '0429',
      'pinYin': 'hu lu dao shi'
    }, {
      'provinceID': 8,
      'cityID': 360,
      'title': '营口市',
      'prefix': '0417',
      'pinYin': 'ying kou shi'
    }, {
      'provinceID': 8,
      'cityID': 361,
      'title': '阜新市',
      'prefix': '0418',
      'pinYin': 'fu xin shi'
    }, {
      'provinceID': 8,
      'cityID': 362,
      'title': '辽阳市',
      'prefix': '0419',
      'pinYin': 'liao yang shi'
    }, {
      'provinceID': 8,
      'cityID': 363,
      'title': '铁岭市',
      'prefix': '0410',
      'pinYin': 'tie ling shi'
    }, {
      'provinceID': 8,
      'cityID': 364,
      'title': '朝阳市',
      'prefix': '0421',
      'pinYin': 'chao yang shi'
    }, {
      'provinceID': 8,
      'cityID': 2207,
      'title': '盘锦市',
      'prefix': '0427',
      'pinYin': 'pan jin shi'
    }, {
      'provinceID': 8,
      'cityID': 365,
      'title': '瓦房店市',
      'prefix': '0411',
      'pinYin': 'wa fang dian shi'
    }, {
      'provinceID': 8,
      'cityID': 366,
      'title': '海城市',
      'prefix': '0412',
      'pinYin': 'hai cheng shi'
    }, {
      'provinceID': 8,
      'cityID': 367,
      'title': '兴城市',
      'prefix': '0429',
      'pinYin': 'xing cheng shi'
    }, {
      'provinceID': 8,
      'cityID': 368,
      'title': '调兵山市',
      'prefix': '0410',
      'pinYin': 'tie fa shi'
    }, {
      'provinceID': 8,
      'cityID': 369,
      'title': '北票市',
      'prefix': '0421',
      'pinYin': 'bei piao shi'
    }, {
      'provinceID': 8,
      'cityID': 370,
      'title': '开原市',
      'prefix': '0410',
      'pinYin': 'kai yuan shi'
    }, {
      'provinceID': 8,
      'cityID': 371,
      'title': '新民市',
      'prefix': '024',
      'pinYin': 'xin min shi'
    }, {
      'provinceID': 8,
      'cityID': 374,
      'title': '庄河市',
      'prefix': '0411',
      'pinYin': 'zhuang he shi'
    }, {
      'provinceID': 8,
      'cityID': 384,
      'title': '凤城市',
      'prefix': '0415',
      'pinYin': 'feng cheng shi'
    }, {
      'provinceID': 8,
      'cityID': 389,
      'title': '北镇市',
      'prefix': '0416',
      'pinYin': 'bei zhen shi'
    }, {
      'provinceID': 8,
      'cityID': 397,
      'title': '灯塔市',
      'prefix': '0419',
      'pinYin': 'deng ta shi'
    }, {
      'provinceID': 8,
      'cityID': 404,
      'title': '凌源市',
      'prefix': '0421',
      'pinYin': 'ling yuan shi'
    }, {
      'provinceID': 8,
      'cityID': 2347,
      'title': '盖州市',
      'prefix': '0417',
      'pinYin': 'gai zhou shi'
    }, {
      'provinceID': 8,
      'cityID': 2351,
      'title': '东港市',
      'prefix': '0415',
      'pinYin': 'dong gang shi'
    }, {
      'provinceID': 8,
      'cityID': 2534,
      'title': '普兰店市',
      'prefix': '0411',
      'pinYin': 'pu lan dian shi'
    }, {
      'provinceID': 8,
      'cityID': 2535,
      'title': '凌海市',
      'prefix': '0416',
      'pinYin': 'ling hai shi'
    }, {
      'provinceID': 8,
      'cityID': 2625,
      'title': '大石桥市',
      'prefix': '0417',
      'pinYin': 'da shi qiao shi'
    }, {
      'provinceID': 9,
      'cityID': 407,
      'title': '长春市',
      'prefix': '0431',
      'pinYin': 'chang chun shi'
    }, {
      'provinceID': 9,
      'cityID': 408,
      'title': '吉林市',
      'prefix': '0432',
      'pinYin': 'ji lin shi'
    }, {
      'provinceID': 9,
      'cityID': 409,
      'title': '四平市',
      'prefix': '0434',
      'pinYin': 'si ping shi'
    }, {
      'provinceID': 9,
      'cityID': 410,
      'title': '辽源市',
      'prefix': '0437',
      'pinYin': 'liao yuan shi'
    }, {
      'provinceID': 9,
      'cityID': 411,
      'title': '通化市',
      'prefix': '0435',
      'pinYin': 'tong hua shi'
    }, {
      'provinceID': 9,
      'cityID': 420,
      'title': '白城市',
      'prefix': '0436',
      'pinYin': 'bai cheng shi'
    }, {
      'provinceID': 9,
      'cityID': 2352,
      'title': '白山市',
      'prefix': '0439',
      'pinYin': 'bai shan shi'
    }, {
      'provinceID': 9,
      'cityID': 2353,
      'title': '松原市',
      'prefix': '0438',
      'pinYin': 'song yuan shi'
    }, {
      'provinceID': 9,
      'cityID': 2623,
      'title': '延边朝鲜族自治州',
      'prefix': '0433',
      'pinYin': 'yan bian chao xian zi zhi zhou'
    }, {
      'provinceID': 9,
      'cityID': 413,
      'title': '公主岭市',
      'prefix': '0434',
      'pinYin': 'gong zhu ling shi'
    }, {
      'provinceID': 9,
      'cityID': 414,
      'title': '梅河口市',
      'prefix': '0435',
      'pinYin': 'mei he kou shi'
    }, {
      'provinceID': 9,
      'cityID': 415,
      'title': '集安市',
      'prefix': '0435',
      'pinYin': 'ji an shi'
    }, {
      'provinceID': 9,
      'cityID': 416,
      'title': '九台市',
      'prefix': '0431',
      'pinYin': 'jiu tai shi'
    }, {
      'provinceID': 9,
      'cityID': 417,
      'title': '桦甸市',
      'prefix': '0432',
      'pinYin': 'dian shi'
    }, {
      'provinceID': 9,
      'cityID': 418,
      'title': '蛟河市',
      'prefix': '0432',
      'pinYin': 'he shi'
    }, {
      'provinceID': 9,
      'cityID': 419,
      'title': '榆树市',
      'prefix': '0431',
      'pinYin': 'yu shu shi'
    }, {
      'provinceID': 9,
      'cityID': 421,
      'title': '洮南市',
      'prefix': '0436',
      'pinYin': 'nan shi'
    }, {
      'provinceID': 9,
      'cityID': 423,
      'title': '大安市',
      'prefix': '0436',
      'pinYin': 'da an shi'
    }, {
      'provinceID': 9,
      'cityID': 424,
      'title': '延吉市',
      'prefix': '0433',
      'pinYin': 'yan ji shi'
    }, {
      'provinceID': 9,
      'cityID': 425,
      'title': '图们市',
      'prefix': '0433',
      'pinYin': 'tu men shi'
    }, {
      'provinceID': 9,
      'cityID': 426,
      'title': '敦化市',
      'prefix': '0433',
      'pinYin': 'dun hua shi'
    }, {
      'provinceID': 9,
      'cityID': 427,
      'title': '龙井市',
      'prefix': '0433',
      'pinYin': 'long jing shi'
    }, {
      'provinceID': 9,
      'cityID': 428,
      'title': '珲春市',
      'prefix': '0433',
      'pinYin': 'chun shi'
    }, {
      'provinceID': 9,
      'cityID': 431,
      'title': '德惠市',
      'prefix': '0431',
      'pinYin': 'de hui shi'
    }, {
      'provinceID': 9,
      'cityID': 433,
      'title': '磐石市',
      'prefix': '0432',
      'pinYin': 'pan shi shi'
    }, {
      'provinceID': 9,
      'cityID': 434,
      'title': '舒兰市',
      'prefix': '0432',
      'pinYin': 'shu lan shi'
    }, {
      'provinceID': 9,
      'cityID': 436,
      'title': '双辽市',
      'prefix': '0434',
      'pinYin': 'shuang liao shi'
    }, {
      'provinceID': 9,
      'cityID': 453,
      'title': '和龙市',
      'prefix': '0433',
      'pinYin': 'he long shi'
    }, {
      'provinceID': 9,
      'cityID': 2354,
      'title': '临江市',
      'prefix': '0439',
      'pinYin': 'lin jiang shi'
    }, {
      'provinceID': 10,
      'cityID': 454,
      'title': '哈尔滨市',
      'prefix': '0451',
      'pinYin': 'ha er bin shi'
    }, {
      'provinceID': 10,
      'cityID': 455,
      'title': '齐齐哈尔市',
      'prefix': '0452',
      'pinYin': 'qi qi ha er shi'
    }, {
      'provinceID': 10,
      'cityID': 456,
      'title': '鹤岗市',
      'prefix': '0468',
      'pinYin': 'he gang shi'
    }, {
      'provinceID': 10,
      'cityID': 457,
      'title': '双鸭山市',
      'prefix': '0469',
      'pinYin': 'shuang ya shan shi'
    }, {
      'provinceID': 10,
      'cityID': 458,
      'title': '鸡西市',
      'prefix': '0467',
      'pinYin': 'ji xi shi'
    }, {
      'provinceID': 10,
      'cityID': 459,
      'title': '大庆市',
      'prefix': '0459',
      'pinYin': 'da qing shi'
    }, {
      'provinceID': 10,
      'cityID': 460,
      'title': '伊春市',
      'prefix': '0458',
      'pinYin': 'yi chun shi'
    }, {
      'provinceID': 10,
      'cityID': 461,
      'title': '牡丹江市',
      'prefix': '0453',
      'pinYin': 'mu dan jiang shi'
    }, {
      'provinceID': 10,
      'cityID': 462,
      'title': '佳木斯市',
      'prefix': '0454',
      'pinYin': 'jia mu si shi'
    }, {
      'provinceID': 10,
      'cityID': 463,
      'title': '七台河市',
      'prefix': '0464',
      'pinYin': 'qi tai he shi'
    }, {
      'provinceID': 10,
      'cityID': 470,
      'title': '绥化市',
      'prefix': '0455',
      'pinYin': 'sui hua shi'
    }, {
      'provinceID': 10,
      'cityID': 474,
      'title': '黑河市',
      'prefix': '0456',
      'pinYin': 'hei he shi'
    }, {
      'provinceID': 10,
      'cityID': 534,
      'title': '大兴安岭地区',
      'prefix': '0457',
      'pinYin': 'da xing an ling di qu'
    }, {
      'provinceID': 10,
      'cityID': 464,
      'title': '绥芬河市',
      'prefix': '0453',
      'pinYin': 'sui fen he shi'
    }, {
      'provinceID': 10,
      'cityID': 466,
      'title': '同江市',
      'prefix': '0454',
      'pinYin': 'tong jiang shi'
    }, {
      'provinceID': 10,
      'cityID': 467,
      'title': '富锦市',
      'prefix': '0454',
      'pinYin': 'fu jin shi'
    }, {
      'provinceID': 10,
      'cityID': 468,
      'title': '铁力市',
      'prefix': '0458',
      'pinYin': 'tie li shi'
    }, {
      'provinceID': 10,
      'cityID': 469,
      'title': '密山市',
      'prefix': '0467',
      'pinYin': 'mi shan shi'
    }, {
      'provinceID': 10,
      'cityID': 471,
      'title': '安达市',
      'prefix': '0455',
      'pinYin': 'an da shi'
    }, {
      'provinceID': 10,
      'cityID': 472,
      'title': '肇东市',
      'prefix': '0455',
      'pinYin': 'zhao dong shi'
    }, {
      'provinceID': 10,
      'cityID': 473,
      'title': '海伦市',
      'prefix': '0455',
      'pinYin': 'hai lun shi'
    }, {
      'provinceID': 10,
      'cityID': 475,
      'title': '北安市',
      'prefix': '0456',
      'pinYin': 'bei an shi'
    }, {
      'provinceID': 10,
      'cityID': 476,
      'title': '五大连池市',
      'prefix': '0456',
      'pinYin': 'wu da lian chi shi'
    }, {
      'provinceID': 10,
      'cityID': 477,
      'title': '尚志市',
      'prefix': '0451',
      'pinYin': 'shang zhi shi'
    }, {
      'provinceID': 10,
      'cityID': 478,
      'title': '双城市',
      'prefix': '0451',
      'pinYin': 'shuang cheng shi'
    }, {
      'provinceID': 10,
      'cityID': 483,
      'title': '讷河市',
      'prefix': '0452',
      'pinYin': 'ne he shi'
    }, {
      'provinceID': 10,
      'cityID': 499,
      'title': '海林市',
      'prefix': '0453',
      'pinYin': 'hai lin shi'
    }, {
      'provinceID': 10,
      'cityID': 500,
      'title': '穆棱市',
      'prefix': '0453',
      'pinYin': 'mu leng shi'
    }, {
      'provinceID': 10,
      'cityID': 501,
      'title': '虎林市',
      'prefix': '0467',
      'pinYin': 'hu lin shi'
    }, {
      'provinceID': 10,
      'cityID': 502,
      'title': '宁安市',
      'prefix': '0453',
      'pinYin': 'ning an shi'
    }, {
      'provinceID': 10,
      'cityID': 528,
      'title': '五常市',
      'prefix': '0451',
      'pinYin': 'wu chang shi'
    }, {
      'provinceID': 11,
      'cityID': 535,
      'title': '南京市',
      'prefix': '025',
      'pinYin': 'nan jing shi'
    }, {
      'provinceID': 11,
      'cityID': 536,
      'title': '徐州市',
      'prefix': '0516',
      'pinYin': 'xu zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 537,
      'title': '连云港市',
      'prefix': '0518',
      'pinYin': 'lian yun gang shi'
    }, {
      'provinceID': 11,
      'cityID': 539,
      'title': '盐城市',
      'prefix': '0515',
      'pinYin': 'yan cheng shi'
    }, {
      'provinceID': 11,
      'cityID': 540,
      'title': '扬州市',
      'prefix': '0514',
      'pinYin': 'yang zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 541,
      'title': '南通市',
      'prefix': '0513',
      'pinYin': 'nan tong shi'
    }, {
      'provinceID': 11,
      'cityID': 542,
      'title': '镇江市',
      'prefix': '0511',
      'pinYin': 'zhen jiang shi'
    }, {
      'provinceID': 11,
      'cityID': 544,
      'title': '常州市',
      'prefix': '0519',
      'pinYin': 'chang zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 545,
      'title': '无锡市',
      'prefix': '0510',
      'pinYin': 'wu xi shi'
    }, {
      'provinceID': 11,
      'cityID': 546,
      'title': '苏州市',
      'prefix': '0512',
      'pinYin': 'su zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 547,
      'title': '泰州市',
      'prefix': '0523',
      'pinYin': 'tai zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 552,
      'title': '宿迁市',
      'prefix': '0527',
      'pinYin': 'su qian shi'
    }, {
      'provinceID': 11,
      'cityID': 556,
      'title': '淮安市',
      'prefix': '0517',
      'pinYin': 'huai an shi'
    }, {
      'provinceID': 11,
      'cityID': 548,
      'title': '仪征市',
      'prefix': '0514',
      'pinYin': 'yi zheng shi'
    }, {
      'provinceID': 11,
      'cityID': 549,
      'title': '常熟市',
      'prefix': '0512',
      'pinYin': 'chang shu shi'
    }, {
      'provinceID': 11,
      'cityID': 550,
      'title': '张家港市',
      'prefix': '0512',
      'pinYin': 'zhang jia gang shi'
    }, {
      'provinceID': 11,
      'cityID': 551,
      'title': '江阴市',
      'prefix': '0510',
      'pinYin': 'jiang yin shi'
    }, {
      'provinceID': 11,
      'cityID': 553,
      'title': '丹阳市',
      'prefix': '0511',
      'pinYin': 'dan yang shi'
    }, {
      'provinceID': 11,
      'cityID': 554,
      'title': '东台市',
      'prefix': '0515',
      'pinYin': 'dong tai shi'
    }, {
      'provinceID': 11,
      'cityID': 555,
      'title': '兴化市',
      'prefix': '0523',
      'pinYin': 'xing hua shi'
    }, {
      'provinceID': 11,
      'cityID': 557,
      'title': '宜兴市',
      'prefix': '0510',
      'pinYin': 'yi xing shi'
    }, {
      'provinceID': 11,
      'cityID': 558,
      'title': '昆山市',
      'prefix': '0512',
      'pinYin': 'kun shan shi'
    }, {
      'provinceID': 11,
      'cityID': 559,
      'title': '启东市',
      'prefix': '0513',
      'pinYin': 'qi dong shi'
    }, {
      'provinceID': 11,
      'cityID': 560,
      'title': '新沂市',
      'prefix': '0516',
      'pinYin': 'xin yi shi'
    }, {
      'provinceID': 11,
      'cityID': 561,
      'title': '溧阳市',
      'prefix': '0519',
      'pinYin': 'yang shi'
    }, {
      'provinceID': 11,
      'cityID': 589,
      'title': '大丰市',
      'prefix': '0515',
      'pinYin': 'da feng shi'
    }, {
      'provinceID': 11,
      'cityID': 592,
      'title': '泰兴市',
      'prefix': '0523',
      'pinYin': 'tai xing shi'
    }, {
      'provinceID': 11,
      'cityID': 594,
      'title': '江都市',
      'prefix': '0514',
      'pinYin': 'jiang du shi'
    }, {
      'provinceID': 11,
      'cityID': 595,
      'title': '靖江市',
      'prefix': '0523',
      'pinYin': 'jing jiang shi'
    }, {
      'provinceID': 11,
      'cityID': 596,
      'title': '高邮市',
      'prefix': '0514',
      'pinYin': 'gao you shi'
    }, {
      'provinceID': 11,
      'cityID': 598,
      'title': '如皋市',
      'prefix': '0513',
      'pinYin': 'ru gao shi'
    }, {
      'provinceID': 11,
      'cityID': 600,
      'title': '海门市',
      'prefix': '0513',
      'pinYin': 'hai men shi'
    }, {
      'provinceID': 11,
      'cityID': 603,
      'title': '句容市',
      'prefix': '0511',
      'pinYin': 'ju rong shi'
    }, {
      'provinceID': 11,
      'cityID': 604,
      'title': '扬中市',
      'prefix': '0511',
      'pinYin': 'yang zhong shi'
    }, {
      'provinceID': 11,
      'cityID': 606,
      'title': '金坛市',
      'prefix': '0519',
      'pinYin': 'jin tan shi'
    }, {
      'provinceID': 11,
      'cityID': 609,
      'title': '吴江市',
      'prefix': '0512',
      'pinYin': 'wu jiang shi'
    }, {
      'provinceID': 11,
      'cityID': 610,
      'title': '太仓市',
      'prefix': '0512',
      'pinYin': 'tai cang shi'
    }, {
      'provinceID': 11,
      'cityID': 2211,
      'title': '通州市',
      'prefix': '0513',
      'pinYin': 'tong zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 2359,
      'title': '邳州市',
      'prefix': '0516',
      'pinYin': 'pi zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 2624,
      'title': '姜堰市',
      'prefix': '0523',
      'pinYin': 'jiang yan shi'
    }, {
      'provinceID': 12,
      'cityID': 611,
      'title': '合肥市',
      'prefix': '0551',
      'pinYin': 'he fei shi'
    }, {
      'provinceID': 12,
      'cityID': 612,
      'title': '淮南市',
      'prefix': '0554',
      'pinYin': 'huai nan shi'
    }, {
      'provinceID': 12,
      'cityID': 613,
      'title': '淮北市',
      'prefix': '0561',
      'pinYin': 'huai bei shi'
    }, {
      'provinceID': 12,
      'cityID': 614,
      'title': '芜湖市',
      'prefix': '0553',
      'pinYin': 'wu hu shi'
    }, {
      'provinceID': 12,
      'cityID': 615,
      'title': '铜陵市',
      'prefix': '0562',
      'pinYin': 'tong ling shi'
    }, {
      'provinceID': 12,
      'cityID': 616,
      'title': '蚌埠市',
      'prefix': '0552',
      'pinYin': 'bang bu shi'
    }, {
      'provinceID': 12,
      'cityID': 617,
      'title': '马鞍山市',
      'prefix': '0555',
      'pinYin': 'ma an shan shi'
    }, {
      'provinceID': 12,
      'cityID': 618,
      'title': '安庆市',
      'prefix': '0556',
      'pinYin': 'an qing shi'
    }, {
      'provinceID': 12,
      'cityID': 619,
      'title': '黄山市',
      'prefix': '0559',
      'pinYin': 'huang shan shi'
    }, {
      'provinceID': 12,
      'cityID': 620,
      'title': '宿州市',
      'prefix': '0557',
      'pinYin': 'su zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 621,
      'title': '滁州市',
      'prefix': '0550',
      'pinYin': 'chu zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 622,
      'title': '巢湖市',
      'prefix': '0565',
      'pinYin': 'chao hu shi'
    }, {
      'provinceID': 12,
      'cityID': 626,
      'title': '六安市',
      'prefix': '0564',
      'pinYin': 'liu an shi'
    }, {
      'provinceID': 12,
      'cityID': 627,
      'title': '阜阳市',
      'prefix': '0558',
      'pinYin': 'fu yang shi'
    }, {
      'provinceID': 12,
      'cityID': 628,
      'title': '亳州市',
      'prefix': '0558',
      'pinYin': 'hao zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 2368,
      'title': '宣城市',
      'prefix': '0563',
      'pinYin': 'xuan cheng shi'
    }, {
      'provinceID': 12,
      'cityID': 2602,
      'title': '池州市',
      'prefix': '0566',
      'pinYin': 'chi zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 629,
      'title': '界首市',
      'prefix': '0558',
      'pinYin': 'jie shou shi'
    }, {
      'provinceID': 12,
      'cityID': 643,
      'title': '桐城市',
      'prefix': '0556',
      'pinYin': 'tong cheng shi'
    }, {
      'provinceID': 12,
      'cityID': 663,
      'title': '天长市',
      'prefix': '0550',
      'pinYin': 'tian chang shi'
    }, {
      'provinceID': 12,
      'cityID': 671,
      'title': '宁国市',
      'prefix': '0563',
      'pinYin': 'ning guo shi'
    }, {
      'provinceID': 12,
      'cityID': 2366,
      'title': '明光市',
      'prefix': '0550',
      'pinYin': 'ming guang shi'
    }, {
      'provinceID': 13,
      'cityID': 692,
      'title': '济南市',
      'prefix': '0531',
      'pinYin': 'ji nan shi'
    }, {
      'provinceID': 13,
      'cityID': 693,
      'title': '青岛市',
      'prefix': '0532',
      'pinYin': 'qing dao shi'
    }, {
      'provinceID': 13,
      'cityID': 694,
      'title': '淄博市',
      'prefix': '0533',
      'pinYin': 'zi bo shi'
    }, {
      'provinceID': 13,
      'cityID': 695,
      'title': '枣庄市',
      'prefix': '0632',
      'pinYin': 'zao zhuang shi'
    }, {
      'provinceID': 13,
      'cityID': 696,
      'title': '东营市',
      'prefix': '0546',
      'pinYin': 'dong ying shi'
    }, {
      'provinceID': 13,
      'cityID': 698,
      'title': '烟台市',
      'prefix': '0535',
      'pinYin': 'yan tai shi'
    }, {
      'provinceID': 13,
      'cityID': 699,
      'title': '威海市',
      'prefix': '0631',
      'pinYin': 'wei hai shi'
    }, {
      'provinceID': 13,
      'cityID': 700,
      'title': '济宁市',
      'prefix': '0537',
      'pinYin': 'ji ning shi'
    }, {
      'provinceID': 13,
      'cityID': 701,
      'title': '泰安市',
      'prefix': '0538',
      'pinYin': 'tai an shi'
    }, {
      'provinceID': 13,
      'cityID': 702,
      'title': '日照市',
      'prefix': '0633',
      'pinYin': 'ri zhao shi'
    }, {
      'provinceID': 13,
      'cityID': 706,
      'title': '莱芜市',
      'prefix': '0634',
      'pinYin': 'lai wu shi'
    }, {
      'provinceID': 13,
      'cityID': 719,
      'title': '德州市',
      'prefix': '0534',
      'pinYin': 'de zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 721,
      'title': '滨州市',
      'prefix': '0543',
      'pinYin': 'bin zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 722,
      'title': '临沂市',
      'prefix': '0539',
      'pinYin': 'lin yi shi'
    }, {
      'provinceID': 13,
      'cityID': 724,
      'title': '聊城市',
      'prefix': '0635',
      'pinYin': 'liao cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 2208,
      'title': '潍坊市',
      'prefix': '0536',
      'pinYin': 'wei fang shi'
    }, {
      'provinceID': 13,
      'cityID': 2209,
      'title': '菏泽市',
      'prefix': '0530',
      'pinYin': 'he ze shi'
    }, {
      'provinceID': 13,
      'cityID': 703,
      'title': '青州市',
      'prefix': '0536',
      'pinYin': 'qing zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 704,
      'title': '龙口市',
      'prefix': '0535',
      'pinYin': 'long kou shi'
    }, {
      'provinceID': 13,
      'cityID': 705,
      'title': '曲阜市',
      'prefix': '0537',
      'pinYin': 'qu fu shi'
    }, {
      'provinceID': 13,
      'cityID': 707,
      'title': '新泰市',
      'prefix': '0538',
      'pinYin': 'xin tai shi'
    }, {
      'provinceID': 13,
      'cityID': 708,
      'title': '胶州市',
      'prefix': '0532',
      'pinYin': 'jiao zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 709,
      'title': '诸城市',
      'prefix': '0536',
      'pinYin': 'zhu cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 710,
      'title': '莱阳市',
      'prefix': '0535',
      'pinYin': 'lai yang shi'
    }, {
      'provinceID': 13,
      'cityID': 711,
      'title': '莱州市',
      'prefix': '0535',
      'pinYin': 'lai zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 712,
      'title': '滕州市',
      'prefix': '0632',
      'pinYin': 'zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 713,
      'title': '文登市',
      'prefix': '0631',
      'pinYin': 'wen deng shi'
    }, {
      'provinceID': 13,
      'cityID': 714,
      'title': '荣成市',
      'prefix': '0631',
      'pinYin': 'rong cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 715,
      'title': '即墨市',
      'prefix': '0532',
      'pinYin': 'ji mo shi'
    }, {
      'provinceID': 13,
      'cityID': 716,
      'title': '平度市',
      'prefix': '0532',
      'pinYin': 'ping du shi'
    }, {
      'provinceID': 13,
      'cityID': 717,
      'title': '莱西市',
      'prefix': '0532',
      'pinYin': 'lai xi shi'
    }, {
      'provinceID': 13,
      'cityID': 718,
      'title': '胶南市',
      'prefix': '0532',
      'pinYin': 'jiao nan shi'
    }, {
      'provinceID': 13,
      'cityID': 720,
      'title': '乐陵市',
      'prefix': '0534',
      'pinYin': 'le ling shi'
    }, {
      'provinceID': 13,
      'cityID': 725,
      'title': '临清市',
      'prefix': '0635',
      'pinYin': 'lin qing shi'
    }, {
      'provinceID': 13,
      'cityID': 726,
      'title': '章丘市',
      'prefix': '0531',
      'pinYin': 'zhang qiu shi'
    }, {
      'provinceID': 13,
      'cityID': 737,
      'title': '昌邑市',
      'prefix': '0536',
      'pinYin': 'chang yi shi'
    }, {
      'provinceID': 13,
      'cityID': 739,
      'title': '高密市',
      'prefix': '0536',
      'pinYin': 'gao mi shi'
    }, {
      'provinceID': 13,
      'cityID': 742,
      'title': '安丘市',
      'prefix': '0536',
      'pinYin': 'an qiu shi'
    }, {
      'provinceID': 13,
      'cityID': 743,
      'title': '寿光市',
      'prefix': '0536',
      'pinYin': 'shou guang shi'
    }, {
      'provinceID': 13,
      'cityID': 745,
      'title': '招远市',
      'prefix': '0535',
      'pinYin': 'zhao yuan shi'
    }, {
      'provinceID': 13,
      'cityID': 746,
      'title': '栖霞市',
      'prefix': '0535',
      'pinYin': 'qi xia shi'
    }, {
      'provinceID': 13,
      'cityID': 747,
      'title': '海阳市',
      'prefix': '0535',
      'pinYin': 'hai yang shi'
    }, {
      'provinceID': 13,
      'cityID': 748,
      'title': '蓬莱市',
      'prefix': '0535',
      'pinYin': 'peng lai shi'
    }, {
      'provinceID': 13,
      'cityID': 750,
      'title': '乳山市',
      'prefix': '0631',
      'pinYin': 'ru shan shi'
    }, {
      'provinceID': 13,
      'cityID': 751,
      'title': '兖州市',
      'prefix': '0537',
      'pinYin': 'yan zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 762,
      'title': '肥城市',
      'prefix': '0538',
      'pinYin': 'fei cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 766,
      'title': '禹城市',
      'prefix': '0534',
      'pinYin': 'yu cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 2396,
      'title': '邹城市',
      'prefix': '0537',
      'pinYin': 'zou cheng shi'
    }, {
      'provinceID': 14,
      'cityID': 802,
      'title': '杭州市',
      'prefix': '0571',
      'pinYin': 'hang zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 803,
      'title': '宁波市',
      'prefix': '0574',
      'pinYin': 'ning bo shi'
    }, {
      'provinceID': 14,
      'cityID': 804,
      'title': '温州市',
      'prefix': '0577',
      'pinYin': 'wen zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 805,
      'title': '嘉兴市',
      'prefix': '0573',
      'pinYin': 'jia xing shi'
    }, {
      'provinceID': 14,
      'cityID': 806,
      'title': '湖州市',
      'prefix': '0572',
      'pinYin': 'hu zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 807,
      'title': '绍兴市',
      'prefix': '0575',
      'pinYin': 'shao xing shi'
    }, {
      'provinceID': 14,
      'cityID': 808,
      'title': '金华市',
      'prefix': '0579',
      'pinYin': 'jin hua shi'
    }, {
      'provinceID': 14,
      'cityID': 809,
      'title': '衢州市',
      'prefix': '0570',
      'pinYin': 'zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 810,
      'title': '舟山市',
      'prefix': '0580',
      'pinYin': 'zhou shan shi'
    }, {
      'provinceID': 14,
      'cityID': 826,
      'title': '丽水市',
      'prefix': '0578',
      'pinYin': 'li shui shi'
    }, {
      'provinceID': 14,
      'cityID': 2216,
      'title': '台州市',
      'prefix': '0576',
      'pinYin': 'tai zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 811,
      'title': '余姚市',
      'prefix': '0574',
      'pinYin': 'yu yao shi'
    }, {
      'provinceID': 14,
      'cityID': 812,
      'title': '海宁市',
      'prefix': '0573',
      'pinYin': 'hai ning shi'
    }, {
      'provinceID': 14,
      'cityID': 813,
      'title': '兰溪市',
      'prefix': '0579',
      'pinYin': 'lan xi shi'
    }, {
      'provinceID': 14,
      'cityID': 814,
      'title': '瑞安市',
      'prefix': '0577',
      'pinYin': 'rui an shi'
    }, {
      'provinceID': 14,
      'cityID': 816,
      'title': '江山市',
      'prefix': '0570',
      'pinYin': 'jiang shan shi'
    }, {
      'provinceID': 14,
      'cityID': 818,
      'title': '东阳市',
      'prefix': '0579',
      'pinYin': 'dong yang shi'
    }, {
      'provinceID': 14,
      'cityID': 819,
      'title': '义乌市',
      'prefix': '0579',
      'pinYin': 'yi wu shi'
    }, {
      'provinceID': 14,
      'cityID': 820,
      'title': '慈溪市',
      'prefix': '0574',
      'pinYin': 'ci xi shi'
    }, {
      'provinceID': 14,
      'cityID': 821,
      'title': '奉化市',
      'prefix': '0574',
      'pinYin': 'feng hua shi'
    }, {
      'provinceID': 14,
      'cityID': 822,
      'title': '诸暨市',
      'prefix': '0575',
      'pinYin': 'zhu  shi'
    }, {
      'provinceID': 14,
      'cityID': 824,
      'title': '临海市',
      'prefix': '0576',
      'pinYin': 'lin hai shi'
    }, {
      'provinceID': 14,
      'cityID': 827,
      'title': '龙泉市',
      'prefix': '0578',
      'pinYin': 'long quan shi'
    }, {
      'provinceID': 14,
      'cityID': 829,
      'title': '临安市',
      'prefix': '0571',
      'pinYin': 'lin an shi'
    }, {
      'provinceID': 14,
      'cityID': 831,
      'title': '富阳市',
      'prefix': '0571',
      'pinYin': 'fu yang shi'
    }, {
      'provinceID': 14,
      'cityID': 832,
      'title': '建德市',
      'prefix': '0571',
      'pinYin': 'jian de shi'
    }, {
      'provinceID': 14,
      'cityID': 843,
      'title': '乐清市',
      'prefix': '0577',
      'pinYin': 'le qing shi'
    }, {
      'provinceID': 14,
      'cityID': 846,
      'title': '平湖市',
      'prefix': '0573',
      'pinYin': 'ping hu shi'
    }, {
      'provinceID': 14,
      'cityID': 848,
      'title': '桐乡市',
      'prefix': '0573',
      'pinYin': 'tong shig shi'
    }, {
      'provinceID': 14,
      'cityID': 855,
      'title': '上虞市',
      'prefix': '0575',
      'pinYin': 'shang yu shi'
    }, {
      'provinceID': 14,
      'cityID': 858,
      'title': '永康市',
      'prefix': '0579',
      'pinYin': 'yong kang shi'
    }, {
      'provinceID': 14,
      'cityID': 869,
      'title': '温岭市',
      'prefix': '0576',
      'pinYin': 'wen ling shi'
    }, {
      'provinceID': 14,
      'cityID': 2361,
      'title': '嵊州市',
      'prefix': '0575',
      'pinYin': 'sheng zhou shi'
    }, {
      'provinceID': 15,
      'cityID': 879,
      'title': '南昌市',
      'prefix': '0791',
      'pinYin': 'nan chang shi'
    }, {
      'provinceID': 15,
      'cityID': 880,
      'title': '景德镇市',
      'prefix': '0798',
      'pinYin': 'jing de zhen shi'
    }, {
      'provinceID': 15,
      'cityID': 881,
      'title': '萍乡市',
      'prefix': '0799',
      'pinYin': 'ping xiang shi'
    }, {
      'provinceID': 15,
      'cityID': 882,
      'title': '新余市',
      'prefix': '0790',
      'pinYin': 'xin yu shi'
    }, {
      'provinceID': 15,
      'cityID': 883,
      'title': '九江市',
      'prefix': '0792',
      'pinYin': 'jiu jiang shi'
    }, {
      'provinceID': 15,
      'cityID': 884,
      'title': '鹰潭市',
      'prefix': '0701',
      'pinYin': 'ying tan shi'
    }, {
      'provinceID': 15,
      'cityID': 886,
      'title': '上饶市',
      'prefix': '0793',
      'pinYin': 'shang rao shi'
    }, {
      'provinceID': 15,
      'cityID': 888,
      'title': '宜春市',
      'prefix': '0795',
      'pinYin': 'yi chun shi'
    }, {
      'provinceID': 15,
      'cityID': 892,
      'title': '吉安市',
      'prefix': '0796',
      'pinYin': 'ji an shi'
    }, {
      'provinceID': 15,
      'cityID': 894,
      'title': '赣州市',
      'prefix': '0797',
      'pinYin': 'gan zhou shi'
    }, {
      'provinceID': 15,
      'cityID': 2377,
      'title': '抚州市',
      'prefix': '0794',
      'pinYin': 'fu zhou shi'
    }, {
      'provinceID': 15,
      'cityID': 885,
      'title': '瑞昌市',
      'prefix': '0792',
      'pinYin': 'rui chang shi'
    }, {
      'provinceID': 15,
      'cityID': 887,
      'title': '德兴市',
      'prefix': '0793',
      'pinYin': 'de xing shi'
    }, {
      'provinceID': 15,
      'cityID': 889,
      'title': '丰城市',
      'prefix': '0795',
      'pinYin': 'feng cheng shi'
    }, {
      'provinceID': 15,
      'cityID': 890,
      'title': '樟树市',
      'prefix': '0795',
      'pinYin': 'zhang shu shi'
    }, {
      'provinceID': 15,
      'cityID': 899,
      'title': '乐平市',
      'prefix': '0798',
      'pinYin': 'le ping shi'
    }, {
      'provinceID': 15,
      'cityID': 911,
      'title': '贵溪市',
      'prefix': '0701',
      'pinYin': 'gui xi shi'
    }, {
      'provinceID': 15,
      'cityID': 925,
      'title': '高安市',
      'prefix': '0795',
      'pinYin': 'gao an shi'
    }, {
      'provinceID': 15,
      'cityID': 957,
      'title': '南康市',
      'prefix': '0797',
      'pinYin': 'nan kang shi'
    }, {
      'provinceID': 15,
      'cityID': 964,
      'title': '瑞金市',
      'prefix': '0797',
      'pinYin': 'rui jin shi'
    }, {
      'provinceID': 15,
      'cityID': 2376,
      'title': '井冈山市',
      'prefix': '0796',
      'pinYin': 'jing gang shan shi'
    }, {
      'provinceID': 16,
      'cityID': 969,
      'title': '福州市',
      'prefix': '0591',
      'pinYin': 'fu zhou shi'
    }, {
      'provinceID': 16,
      'cityID': 970,
      'title': '厦门市',
      'prefix': '0592',
      'pinYin': 'xia men shi'
    }, {
      'provinceID': 16,
      'cityID': 971,
      'title': '三明市',
      'prefix': '0598',
      'pinYin': 'san ming shi'
    }, {
      'provinceID': 16,
      'cityID': 972,
      'title': '莆田市',
      'prefix': '0594',
      'pinYin': 'pu tian shi'
    }, {
      'provinceID': 16,
      'cityID': 973,
      'title': '泉州市',
      'prefix': '0595',
      'pinYin': 'quan zhou shi'
    }, {
      'provinceID': 16,
      'cityID': 974,
      'title': '漳州市',
      'prefix': '0596',
      'pinYin': 'zhang zhou shi'
    }, {
      'provinceID': 16,
      'cityID': 978,
      'title': '南平市',
      'prefix': '0599',
      'pinYin': 'nan ping shi'
    }, {
      'provinceID': 16,
      'cityID': 981,
      'title': '宁德市',
      'prefix': '0593',
      'pinYin': 'ning de shi'
    }, {
      'provinceID': 16,
      'cityID': 983,
      'title': '龙岩市',
      'prefix': '0597',
      'pinYin': 'long yan shi'
    }, {
      'provinceID': 16,
      'cityID': 975,
      'title': '永安市',
      'prefix': '0598',
      'pinYin': 'yong an shi'
    }, {
      'provinceID': 16,
      'cityID': 976,
      'title': '石狮市',
      'prefix': '0595',
      'pinYin': 'shi shi shi'
    }, {
      'provinceID': 16,
      'cityID': 977,
      'title': '福清市',
      'prefix': '0591',
      'pinYin': 'fu qing shi'
    }, {
      'provinceID': 16,
      'cityID': 979,
      'title': '邵武市',
      'prefix': '0599',
      'pinYin': 'shao wu shi'
    }, {
      'provinceID': 16,
      'cityID': 980,
      'title': '武夷山市',
      'prefix': '0599',
      'pinYin': 'wu yi shan shi'
    }, {
      'provinceID': 16,
      'cityID': 982,
      'title': '福安市',
      'prefix': '0593',
      'pinYin': 'fu an shi'
    }, {
      'provinceID': 16,
      'cityID': 984,
      'title': '漳平市',
      'prefix': '0597',
      'pinYin': 'zhang ping shi'
    }, {
      'provinceID': 16,
      'cityID': 991,
      'title': '长乐市',
      'prefix': '0591',
      'pinYin': 'chang le shi'
    }, {
      'provinceID': 16,
      'cityID': 1007,
      'title': '南安市',
      'prefix': '0595',
      'pinYin': 'nan an shi'
    }, {
      'provinceID': 16,
      'cityID': 1008,
      'title': '晋江市',
      'prefix': '0595',
      'pinYin': 'jin jiang shi'
    }, {
      'provinceID': 16,
      'cityID': 1011,
      'title': '龙海市',
      'prefix': '0596',
      'pinYin': 'long hai shi'
    }, {
      'provinceID': 16,
      'cityID': 1020,
      'title': '建阳市',
      'prefix': '0599',
      'pinYin': 'jian yang shi'
    }, {
      'provinceID': 16,
      'cityID': 1023,
      'title': '建瓯市',
      'prefix': '0599',
      'pinYin': 'jian ou xian'
    }, {
      'provinceID': 16,
      'cityID': 1032,
      'title': '福鼎市',
      'prefix': '0593',
      'pinYin': 'fu ding shi'
    }, {
      'provinceID': 17,
      'cityID': 1040,
      'title': '长沙市',
      'prefix': '0731',
      'pinYin': 'chang sha shi'
    }, {
      'provinceID': 17,
      'cityID': 1041,
      'title': '株洲市',
      'prefix': '0731',
      'pinYin': 'zhu zhou shi'
    }, {
      'provinceID': 17,
      'cityID': 1042,
      'title': '湘潭市',
      'prefix': '0731',
      'pinYin': 'xiang tan shi'
    }, {
      'provinceID': 17,
      'cityID': 1043,
      'title': '衡阳市',
      'prefix': '0734',
      'pinYin': 'heng yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1044,
      'title': '岳阳市',
      'prefix': '0730',
      'pinYin': 'yue yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1045,
      'title': '常德市',
      'prefix': '0736',
      'pinYin': 'chang de shi'
    }, {
      'provinceID': 17,
      'cityID': 1046,
      'title': '张家界市',
      'prefix': '0744',
      'pinYin': 'da yong shi'
    }, {
      'provinceID': 17,
      'cityID': 1053,
      'title': '郴州市',
      'prefix': '0735',
      'pinYin': 'chen zhou shi'
    }, {
      'provinceID': 17,
      'cityID': 1055,
      'title': '永州市',
      'prefix': '0746',
      'pinYin': 'yong zhou shi'
    }, {
      'provinceID': 17,
      'cityID': 1057,
      'title': '娄底市',
      'prefix': '0738',
      'pinYin': 'lou di shi'
    }, {
      'provinceID': 17,
      'cityID': 1060,
      'title': '怀化市',
      'prefix': '0745',
      'pinYin': 'huai hua shi'
    }, {
      'provinceID': 17,
      'cityID': 1062,
      'title': '益阳市',
      'prefix': '0737',
      'pinYin': 'yi yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1080,
      'title': '邵阳市',
      'prefix': '0739',
      'pinYin': 'shao yang shi'
    }, {
      'provinceID': 17,
      'cityID': 2621,
      'title': '湘西土家族苗族自治州',
      'prefix': '0743',
      'pinYin': 'xiang xi tu jia zu miao zu zi zhi zhou'
    }, {
      'provinceID': 17,
      'cityID': 1047,
      'title': '醴陵市',
      'prefix': '0731',
      'pinYin': 'ling shi'
    }, {
      'provinceID': 17,
      'cityID': 1048,
      'title': '湘乡市',
      'prefix': '0731',
      'pinYin': 'xiang xiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1051,
      'title': '津市市',
      'prefix': '0736',
      'pinYin': 'jin shi shi'
    }, {
      'provinceID': 17,
      'cityID': 1052,
      'title': '韶山市',
      'prefix': '0731',
      'pinYin': 'shao shan shi'
    }, {
      'provinceID': 17,
      'cityID': 1054,
      'title': '资兴市',
      'prefix': '0735',
      'pinYin': 'zi xing shi'
    }, {
      'provinceID': 17,
      'cityID': 1058,
      'title': '冷水江市',
      'prefix': '0738',
      'pinYin': 'leng shui jiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1059,
      'title': '涟源市',
      'prefix': '0738',
      'pinYin': 'lian yuan shi'
    }, {
      'provinceID': 17,
      'cityID': 1061,
      'title': '洪江市',
      'prefix': '0745',
      'pinYin': 'hong jiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1063,
      'title': '沅江市',
      'prefix': '0737',
      'pinYin': 'jiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1064,
      'title': '吉首市',
      'prefix': '0743',
      'pinYin': 'ji shou shi'
    }, {
      'provinceID': 17,
      'cityID': 1068,
      'title': '浏阳市',
      'prefix': '0731',
      'pinYin': 'liu yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1076,
      'title': '武冈市',
      'prefix': '0739',
      'pinYin': 'wu gang shi'
    }, {
      'provinceID': 17,
      'cityID': 1086,
      'title': '临湘市',
      'prefix': '0730',
      'pinYin': 'lin shig shi'
    }, {
      'provinceID': 17,
      'cityID': 2416,
      'title': '耒阳市',
      'prefix': '0734',
      'pinYin': 'lei yang shi'
    }, {
      'provinceID': 17,
      'cityID': 2421,
      'title': '常宁市',
      'prefix': '0734',
      'pinYin': 'chang ning shi'
    }, {
      'provinceID': 17,
      'cityID': 2622,
      'title': '汨罗市',
      'prefix': '0730',
      'pinYin': 'mi luo shi'
    }, {
      'provinceID': 18,
      'cityID': 1138,
      'title': '武汉市',
      'prefix': '027',
      'pinYin': 'wu han shi'
    }, {
      'provinceID': 18,
      'cityID': 1139,
      'title': '黄石市',
      'prefix': '0714',
      'pinYin': 'huang shi shi'
    }, {
      'provinceID': 18,
      'cityID': 1140,
      'title': '襄樊市',
      'prefix': '0710',
      'pinYin': 'xiang fan shi'
    }, {
      'provinceID': 18,
      'cityID': 1142,
      'title': '荆州市',
      'prefix': '0716',
      'pinYin': 'jing zhou shi'
    }, {
      'provinceID': 18,
      'cityID': 1144,
      'title': '荆门市',
      'prefix': '0724',
      'pinYin': 'jing men shi'
    }, {
      'provinceID': 18,
      'cityID': 1145,
      'title': '鄂州市',
      'prefix': '0711',
      'pinYin': 'e zhou shi'
    }, {
      'provinceID': 18,
      'cityID': 1146,
      'title': '随州市',
      'prefix': '0722',
      'pinYin': 'sui zhou shi'
    }, {
      'provinceID': 18,
      'cityID': 1149,
      'title': '孝感市',
      'prefix': '0712',
      'pinYin': 'xiao gan shi'
    }, {
      'provinceID': 18,
      'cityID': 1156,
      'title': '咸宁市',
      'prefix': '0715',
      'pinYin': 'xian ning shi'
    }, {
      'provinceID': 18,
      'cityID': 1158,
      'title': '仙桃市',
      'prefix': '0728',
      'pinYin': 'xian tao shi'
    }, {
      'provinceID': 18,
      'cityID': 1160,
      'title': '天门市',
      'prefix': '0728',
      'pinYin': 'tian men shi'
    }, {
      'provinceID': 18,
      'cityID': 1162,
      'title': '潜江市',
      'prefix': '0728',
      'pinYin': 'qian jiang shi'
    }, {
      'provinceID': 18,
      'cityID': 1163,
      'title': '宜昌市',
      'prefix': '0717',
      'pinYin': 'yi chang shi'
    }, {
      'provinceID': 18,
      'cityID': 1166,
      'title': '十堰市',
      'prefix': '0719',
      'pinYin': 'shi yan shi'
    }, {
      'provinceID': 18,
      'cityID': 1180,
      'title': '神农架林区',
      'prefix': '0719',
      'pinYin': 'shen nong jia lin qu'
    }, {
      'provinceID': 18,
      'cityID': 2412,
      'title': '黄冈市',
      'prefix': '0713',
      'pinYin': 'huang gang shi'
    }, {
      'provinceID': 18,
      'cityID': 2618,
      'title': '恩施土家族苗族自治州',
      'prefix': '0718',
      'pinYin': 'en shi tu jia zu miao zu zi zhi zhou'
    }, {
      'provinceID': 18,
      'cityID': 1147,
      'title': '老河口市',
      'prefix': '0710',
      'pinYin': 'lao he kou shi'
    }, {
      'provinceID': 18,
      'cityID': 1148,
      'title': '枣阳市',
      'prefix': '0710',
      'pinYin': 'zao yang shi'
    }, {
      'provinceID': 18,
      'cityID': 1150,
      'title': '应城市',
      'prefix': '0712',
      'pinYin': 'ying cheng shi'
    }, {
      'provinceID': 18,
      'cityID': 1151,
      'title': '安陆市',
      'prefix': '0712',
      'pinYin': 'an lu shi'
    }, {
      'provinceID': 18,
      'cityID': 1152,
      'title': '广水市',
      'prefix': '0722',
      'pinYin': 'guang shui shi'
    }, {
      'provinceID': 18,
      'cityID': 1153,
      'title': '麻城市',
      'prefix': '0713',
      'pinYin': 'ma cheng shi'
    }, {
      'provinceID': 18,
      'cityID': 1154,
      'title': '武穴市',
      'prefix': '0713',
      'pinYin': 'wu xue shi'
    }, {
      'provinceID': 18,
      'cityID': 1159,
      'title': '石首市',
      'prefix': '0716',
      'pinYin': 'shi shou shi'
    }, {
      'provinceID': 18,
      'cityID': 1161,
      'title': '洪湖市',
      'prefix': '0716',
      'pinYin': 'hong hu shi'
    }, {
      'provinceID': 18,
      'cityID': 1165,
      'title': '当阳市',
      'prefix': '0717',
      'pinYin': 'dang yang shi'
    }, {
      'provinceID': 18,
      'cityID': 1167,
      'title': '丹江口市',
      'prefix': '0719',
      'pinYin': 'dan jiang kou shi'
    }, {
      'provinceID': 18,
      'cityID': 1168,
      'title': '恩施市',
      'prefix': '0718',
      'pinYin': 'en shi shi'
    }, {
      'provinceID': 18,
      'cityID': 1169,
      'title': '利川市',
      'prefix': '0718',
      'pinYin': 'li chuan shi'
    }, {
      'provinceID': 18,
      'cityID': 1181,
      'title': '汉川市',
      'prefix': '0712',
      'pinYin': 'han chuan shi'
    }, {
      'provinceID': 18,
      'cityID': 1197,
      'title': '钟祥市',
      'prefix': '0724',
      'pinYin': 'zhong shig shi'
    }, {
      'provinceID': 18,
      'cityID': 1201,
      'title': '松滋市',
      'prefix': '0716',
      'pinYin': 'song zi shi'
    }, {
      'provinceID': 18,
      'cityID': 1206,
      'title': '枝江市',
      'prefix': '0717',
      'pinYin': 'zhi jiang shi'
    }, {
      'provinceID': 18,
      'cityID': 2410,
      'title': '大冶市',
      'prefix': '0714',
      'pinYin': 'da ye shi'
    }, {
      'provinceID': 18,
      'cityID': 2619,
      'title': '宜都市',
      'prefix': '0717',
      'pinYin': 'yi du shi'
    }, {
      'provinceID': 18,
      'cityID': 2620,
      'title': '赤壁市',
      'prefix': '0715',
      'pinYin': 'chi bi shi'
    }, {
      'provinceID': 19,
      'cityID': 1220,
      'title': '郑州市',
      'prefix': '0371',
      'pinYin': 'zheng zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1221,
      'title': '开封市',
      'prefix': '0378',
      'pinYin': 'kai feng shi'
    }, {
      'provinceID': 19,
      'cityID': 1222,
      'title': '洛阳市',
      'prefix': '0379',
      'pinYin': 'luo yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1223,
      'title': '平顶山市',
      'prefix': '0375',
      'pinYin': 'ping ding shan shi'
    }, {
      'provinceID': 19,
      'cityID': 1224,
      'title': '焦作市',
      'prefix': '0391',
      'pinYin': 'jiao zuo shi'
    }, {
      'provinceID': 19,
      'cityID': 1225,
      'title': '鹤壁市',
      'prefix': '0392',
      'pinYin': 'he bi shi'
    }, {
      'provinceID': 19,
      'cityID': 1226,
      'title': '新乡市',
      'prefix': '0373',
      'pinYin': 'xin xiang shi'
    }, {
      'provinceID': 19,
      'cityID': 1227,
      'title': '安阳市',
      'prefix': '0372',
      'pinYin': 'an yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1228,
      'title': '濮阳市',
      'prefix': '0393',
      'pinYin': 'yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1229,
      'title': '许昌市',
      'prefix': '0374',
      'pinYin': 'xu chang shi'
    }, {
      'provinceID': 19,
      'cityID': 1230,
      'title': '漯河市',
      'prefix': '0395',
      'pinYin': 'he shi'
    }, {
      'provinceID': 19,
      'cityID': 1231,
      'title': '三门峡市',
      'prefix': '0398',
      'pinYin': 'san men xia shi'
    }, {
      'provinceID': 19,
      'cityID': 1234,
      'title': '济源市',
      'prefix': '0391',
      'pinYin': 'ji yuan shi'
    }, {
      'provinceID': 19,
      'cityID': 1240,
      'title': '商丘市',
      'prefix': '0370',
      'pinYin': 'shang qiu shi'
    }, {
      'provinceID': 19,
      'cityID': 1241,
      'title': '周口市',
      'prefix': '0394',
      'pinYin': 'zhou kou shi'
    }, {
      'provinceID': 19,
      'cityID': 1242,
      'title': '驻马店市',
      'prefix': '0396',
      'pinYin': 'zhu ma dian shi'
    }, {
      'provinceID': 19,
      'cityID': 1243,
      'title': '信阳市',
      'prefix': '0376',
      'pinYin': 'xin yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1244,
      'title': '南阳市',
      'prefix': '0377',
      'pinYin': 'nan yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1232,
      'title': '义马市',
      'prefix': '0398',
      'pinYin': 'yi ma shi'
    }, {
      'provinceID': 19,
      'cityID': 1233,
      'title': '汝州市',
      'prefix': '0375',
      'pinYin': 'ru zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1235,
      'title': '禹州市',
      'prefix': '0374',
      'pinYin': 'yu zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1236,
      'title': '卫辉市',
      'prefix': '0373',
      'pinYin': 'wei hui shi'
    }, {
      'provinceID': 19,
      'cityID': 1237,
      'title': '辉县市',
      'prefix': '0373',
      'pinYin': 'hui xian shi'
    }, {
      'provinceID': 19,
      'cityID': 1238,
      'title': '沁阳市',
      'prefix': '0391',
      'pinYin': 'qin yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1239,
      'title': '舞钢市',
      'prefix': '0375',
      'pinYin': 'wu gang shi'
    }, {
      'provinceID': 19,
      'cityID': 1245,
      'title': '邓州市',
      'prefix': '0377',
      'pinYin': 'deng zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1246,
      'title': '荥阳市',
      'prefix': '0371',
      'pinYin': 'ying yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1247,
      'title': '登封市',
      'prefix': '0371',
      'pinYin': 'deng feng shi'
    }, {
      'provinceID': 19,
      'cityID': 1249,
      'title': '新郑市',
      'prefix': '0371',
      'pinYin': 'xin zheng shi'
    }, {
      'provinceID': 19,
      'cityID': 1260,
      'title': '偃师市',
      'prefix': '0379',
      'pinYin': 'yan shi shi'
    }, {
      'provinceID': 19,
      'cityID': 1295,
      'title': '长葛市',
      'prefix': '0374',
      'pinYin': 'chang ge shi'
    }, {
      'provinceID': 19,
      'cityID': 1300,
      'title': '灵宝市',
      'prefix': '0398',
      'pinYin': 'ling bao shi'
    }, {
      'provinceID': 19,
      'cityID': 1308,
      'title': '永城市',
      'prefix': '0370',
      'pinYin': 'yong cheng shi'
    }, {
      'provinceID': 19,
      'cityID': 1320,
      'title': '项城市',
      'prefix': '0394',
      'pinYin': 'xiang cheng shi'
    }, {
      'provinceID': 19,
      'cityID': 2398,
      'title': '巩义市',
      'prefix': '0371',
      'pinYin': 'gong yi shi'
    }, {
      'provinceID': 19,
      'cityID': 2403,
      'title': '林州市',
      'prefix': '0372',
      'pinYin': 'lin zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 2616,
      'title': '新密市',
      'prefix': '0371',
      'pinYin': 'xin mi shi'
    }, {
      'provinceID': 19,
      'cityID': 2617,
      'title': '孟州市',
      'prefix': '0391',
      'pinYin': 'meng zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1350,
      'title': '广州市',
      'prefix': '020',
      'pinYin': 'guang zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1351,
      'title': '深圳市',
      'prefix': '0755',
      'pinYin': 'shen  shi'
    }, {
      'provinceID': 20,
      'cityID': 1352,
      'title': '珠海市',
      'prefix': '0756',
      'pinYin': 'zhu hai shi'
    }, {
      'provinceID': 20,
      'cityID': 1353,
      'title': '汕头市',
      'prefix': '0754',
      'pinYin': 'shan tou shi'
    }, {
      'provinceID': 20,
      'cityID': 1354,
      'title': '韶关市',
      'prefix': '0751',
      'pinYin': 'shao guan shi'
    }, {
      'provinceID': 20,
      'cityID': 1355,
      'title': '河源市',
      'prefix': '0762',
      'pinYin': 'he yuan shi'
    }, {
      'provinceID': 20,
      'cityID': 1356,
      'title': '梅州市',
      'prefix': '0753',
      'pinYin': 'mei zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1357,
      'title': '惠州市',
      'prefix': '0752',
      'pinYin': 'hui zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1358,
      'title': '汕尾市',
      'prefix': '0660',
      'pinYin': 'shan wei shi'
    }, {
      'provinceID': 20,
      'cityID': 1359,
      'title': '东莞市',
      'prefix': '0769',
      'pinYin': 'dong  shi'
    }, {
      'provinceID': 20,
      'cityID': 1360,
      'title': '中山市',
      'prefix': '0760',
      'pinYin': 'zhong shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1361,
      'title': '江门市',
      'prefix': '0750',
      'pinYin': 'jiang men shi'
    }, {
      'provinceID': 20,
      'cityID': 1362,
      'title': '佛山市',
      'prefix': '0757',
      'pinYin': 'fo shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1363,
      'title': '阳江市',
      'prefix': '0662',
      'pinYin': 'yang jiang shi'
    }, {
      'provinceID': 20,
      'cityID': 1364,
      'title': '湛江市',
      'prefix': '0759',
      'pinYin': 'zhan jiang shi'
    }, {
      'provinceID': 20,
      'cityID': 1365,
      'title': '茂名市',
      'prefix': '0668',
      'pinYin': 'mao ming shi'
    }, {
      'provinceID': 20,
      'cityID': 1366,
      'title': '肇庆市',
      'prefix': '0758',
      'pinYin': 'zhao qing shi'
    }, {
      'provinceID': 20,
      'cityID': 1367,
      'title': '清远市',
      'prefix': '0763',
      'pinYin': 'qing yuan shi'
    }, {
      'provinceID': 20,
      'cityID': 1368,
      'title': '潮州市',
      'prefix': '0768',
      'pinYin': 'chao zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1382,
      'title': '揭阳市',
      'prefix': '0663',
      'pinYin': 'jie yang shi'
    }, {
      'provinceID': 20,
      'cityID': 1434,
      'title': '云浮市',
      'prefix': '0766',
      'pinYin': 'yun fu shi'
    }, {
      'provinceID': 20,
      'cityID': 1370,
      'title': '从化市',
      'prefix': '020',
      'pinYin': 'cong hua shi'
    }, {
      'provinceID': 20,
      'cityID': 1371,
      'title': '增城市',
      'prefix': '020',
      'pinYin': 'zeng cheng shi'
    }, {
      'provinceID': 20,
      'cityID': 1384,
      'title': '南雄市',
      'prefix': '0751',
      'pinYin': 'nan xiong shi'
    }, {
      'provinceID': 20,
      'cityID': 1389,
      'title': '乐昌市',
      'prefix': '0751',
      'pinYin': 'le chang shi'
    }, {
      'provinceID': 20,
      'cityID': 1400,
      'title': '兴宁市',
      'prefix': '0753',
      'pinYin': 'xing ning shi'
    }, {
      'provinceID': 20,
      'cityID': 1408,
      'title': '陆丰市',
      'prefix': '0660',
      'pinYin': 'lu feng shi'
    }, {
      'provinceID': 20,
      'cityID': 1410,
      'title': '台山市',
      'prefix': '0750',
      'pinYin': 'tai shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1411,
      'title': '开平市',
      'prefix': '0750',
      'pinYin': 'kai ping shi'
    }, {
      'provinceID': 20,
      'cityID': 1412,
      'title': '恩平市',
      'prefix': '0750',
      'pinYin': 'en ping shi'
    }, {
      'provinceID': 20,
      'cityID': 1413,
      'title': '鹤山市',
      'prefix': '0750',
      'pinYin': 'he shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1419,
      'title': '阳春市',
      'prefix': '0662',
      'pinYin': 'yang chun shi'
    }, {
      'provinceID': 20,
      'cityID': 1420,
      'title': '吴川市',
      'prefix': '0759',
      'pinYin': 'wu chuan shi'
    }, {
      'provinceID': 20,
      'cityID': 1424,
      'title': '廉江市',
      'prefix': '0759',
      'pinYin': 'lian jiang shi'
    }, {
      'provinceID': 20,
      'cityID': 1425,
      'title': '高州市',
      'prefix': '0668',
      'pinYin': 'gao zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1426,
      'title': '信宜市',
      'prefix': '0668',
      'pinYin': 'xin yi shi'
    }, {
      'provinceID': 20,
      'cityID': 1428,
      'title': '化州市',
      'prefix': '0668',
      'pinYin': 'hua zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1429,
      'title': '高要市',
      'prefix': '0758',
      'pinYin': 'gao yao shi'
    }, {
      'provinceID': 20,
      'cityID': 1431,
      'title': '四会市',
      'prefix': '0758',
      'pinYin': 'si hui shi'
    }, {
      'provinceID': 20,
      'cityID': 1433,
      'title': '罗定市',
      'prefix': '0766',
      'pinYin': 'luo ding shi'
    }, {
      'provinceID': 20,
      'cityID': 1439,
      'title': '英德市',
      'prefix': '0763',
      'pinYin': 'ying de shi'
    }, {
      'provinceID': 20,
      'cityID': 2425,
      'title': '连州市',
      'prefix': '0763',
      'pinYin': 'lian zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 2428,
      'title': '普宁市',
      'prefix': '0663',
      'pinYin': 'pu ning shi'
    }, {
      'provinceID': 20,
      'cityID': 2607,
      'title': '雷州市',
      'prefix': '0759',
      'pinYin': 'lei zhou shi'
    }, {
      'provinceID': 21,
      'cityID': 1446,
      'title': '海口市',
      'prefix': '0898',
      'pinYin': 'hai kou shi'
    }, {
      'provinceID': 21,
      'cityID': 1447,
      'title': '三亚市',
      'prefix': '0898',
      'pinYin': 'san ya shi'
    }, {
      'provinceID': 21,
      'cityID': 1448,
      'title': '五指山市',
      'prefix': '0898',
      'pinYin': 'tong shi shi'
    }, {
      'provinceID': 21,
      'cityID': 1450,
      'title': '文昌市',
      'prefix': '0898',
      'pinYin': 'wen chang shi'
    }, {
      'provinceID': 21,
      'cityID': 1451,
      'title': '琼海市',
      'prefix': '0898',
      'pinYin': 'qiong hai shi'
    }, {
      'provinceID': 21,
      'cityID': 1452,
      'title': '万宁市',
      'prefix': '0898',
      'pinYin': 'wan ning shi'
    }, {
      'provinceID': 21,
      'cityID': 1460,
      'title': '东方市',
      'prefix': '0898',
      'pinYin': 'dong fang shi'
    }, {
      'provinceID': 21,
      'cityID': 2615,
      'title': '儋州市',
      'prefix': '0898',
      'pinYin': 'dan zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 1465,
      'title': '南宁市',
      'prefix': '0771',
      'pinYin': 'nan ning shi'
    }, {
      'provinceID': 22,
      'cityID': 1466,
      'title': '柳州市',
      'prefix': '0772',
      'pinYin': 'liu zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 1467,
      'title': '桂林市',
      'prefix': '0773',
      'pinYin': 'gui lin shi'
    }, {
      'provinceID': 22,
      'cityID': 1468,
      'title': '梧州市',
      'prefix': '0774',
      'pinYin': 'wu zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 1469,
      'title': '北海市',
      'prefix': '0779',
      'pinYin': 'bei hai shi'
    }, {
      'provinceID': 22,
      'cityID': 1472,
      'title': '玉林市',
      'prefix': '0775',
      'pinYin': 'yu lin shi'
    }, {
      'provinceID': 22,
      'cityID': 1473,
      'title': '贵港市',
      'prefix': '0775',
      'pinYin': 'gui gang shi'
    }, {
      'provinceID': 22,
      'cityID': 1474,
      'title': '百色市',
      'prefix': '0776',
      'pinYin': 'bai se shi'
    }, {
      'provinceID': 22,
      'cityID': 1475,
      'title': '河池市',
      'prefix': '0778',
      'pinYin': 'he chi shi'
    }, {
      'provinceID': 22,
      'cityID': 1497,
      'title': '来宾市',
      'prefix': '0772',
      'pinYin': 'lai bin shi'
    }, {
      'provinceID': 22,
      'cityID': 1517,
      'title': '贺州市',
      'prefix': '0774',
      'pinYin': 'he xian'
    }, {
      'provinceID': 22,
      'cityID': 2430,
      'title': '钦州市',
      'prefix': '0777',
      'pinYin': 'qin zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 2434,
      'title': '祟左',
      'prefix': '',
      'pinYin': 'sui zuo'
    }, {
      'provinceID': 22,
      'cityID': 2435,
      'title': '防城港市',
      'prefix': '0770',
      'pinYin': 'fang cheng gang shi'
    }, {
      'provinceID': 22,
      'cityID': 1470,
      'title': '凭祥市',
      'prefix': '0771',
      'pinYin': 'ping xiang shi'
    }, {
      'provinceID': 22,
      'cityID': 1471,
      'title': '合山市',
      'prefix': '0772',
      'pinYin': 'he shan shi'
    }, {
      'provinceID': 22,
      'cityID': 1488,
      'title': '崇左市',
      'prefix': '0771',
      'pinYin': 'chong zuo shi'
    }, {
      'provinceID': 22,
      'cityID': 1515,
      'title': '岑溪市',
      'prefix': '0774',
      'pinYin': 'cen xi shi'
    }, {
      'provinceID': 22,
      'cityID': 1521,
      'title': '桂平市',
      'prefix': '0775',
      'pinYin': 'gui ping shi'
    }, {
      'provinceID': 22,
      'cityID': 1522,
      'title': '北流市',
      'prefix': '0775',
      'pinYin': 'bei liu shi'
    }, {
      'provinceID': 22,
      'cityID': 2608,
      'title': '宜州市',
      'prefix': '0778',
      'pinYin': 'yi zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 2609,
      'title': '东兴市',
      'prefix': '0770',
      'pinYin': 'dong xing shi'
    }, {
      'provinceID': 23,
      'cityID': 1546,
      'title': '贵阳市',
      'prefix': '0851',
      'pinYin': 'gui yang shi'
    }, {
      'provinceID': 23,
      'cityID': 1547,
      'title': '六盘水市',
      'prefix': '0858',
      'pinYin': 'liu pan shui shi'
    }, {
      'provinceID': 23,
      'cityID': 1548,
      'title': '遵义市',
      'prefix': '0852',
      'pinYin': 'zun yi shi'
    }, {
      'provinceID': 23,
      'cityID': 1552,
      'title': '安顺市',
      'prefix': '0853',
      'pinYin': 'an shun shi'
    }, {
      'provinceID': 23,
      'cityID': 2610,
      'title': '黔西南布依族苗族自治州',
      'prefix': '0859',
      'pinYin': 'qian xi nan bu yi zu miao zu zi zhi zhou'
    }, {
      'provinceID': 23,
      'cityID': 2611,
      'title': '黔东南苗族侗族自治州',
      'prefix': '0855',
      'pinYin': 'qian dong nan miao zu dong zu zi zhi zhou'
    }, {
      'provinceID': 23,
      'cityID': 2612,
      'title': '黔南布依族苗族自治州',
      'prefix': '0854',
      'pinYin': 'qian nan bu yi zu miao zu zi zhi zhou'
    }, {
      'provinceID': 23,
      'cityID': 2613,
      'title': '铜仁地区',
      'prefix': '0856',
      'pinYin': 'tong ren di qu'
    }, {
      'provinceID': 23,
      'cityID': 2614,
      'title': '毕节地区',
      'prefix': '0857',
      'pinYin': 'bi jie di qu'
    }, {
      'provinceID': 23,
      'cityID': 1549,
      'title': '赤水市',
      'prefix': '0852',
      'pinYin': 'chi shui shi'
    }, {
      'provinceID': 23,
      'cityID': 1550,
      'title': '铜仁市',
      'prefix': '0856',
      'pinYin': 'tong ren shi'
    }, {
      'provinceID': 23,
      'cityID': 1553,
      'title': '兴义市',
      'prefix': '0859',
      'pinYin': 'xing yi shi'
    }, {
      'provinceID': 23,
      'cityID': 1554,
      'title': '凯里市',
      'prefix': '0855',
      'pinYin': 'kai li shi'
    }, {
      'provinceID': 23,
      'cityID': 1555,
      'title': '都匀市',
      'prefix': '0854',
      'pinYin': 'du yun shi'
    }, {
      'provinceID': 23,
      'cityID': 1563,
      'title': '仁怀市',
      'prefix': '0852',
      'pinYin': 'ren huai shi'
    }, {
      'provinceID': 23,
      'cityID': 1581,
      'title': '毕节市',
      'prefix': '0857',
      'pinYin': 'bi jie shi'
    }, {
      'provinceID': 23,
      'cityID': 1594,
      'title': '清镇市',
      'prefix': '0851',
      'pinYin': 'qing zhen shi'
    }, {
      'provinceID': 23,
      'cityID': 1627,
      'title': '福泉市',
      'prefix': '0854',
      'pinYin': 'fu quan shi'
    }, {
      'provinceID': 24,
      'cityID': 1631,
      'title': '成都市',
      'prefix': '028',
      'pinYin': 'cheng du shi'
    }, {
      'provinceID': 24,
      'cityID': 1632,
      'title': '自贡市',
      'prefix': '0813',
      'pinYin': 'zi gong shi'
    }, {
      'provinceID': 24,
      'cityID': 1633,
      'title': '攀枝花市',
      'prefix': '0812',
      'pinYin': 'pan zhi hua shi'
    }, {
      'provinceID': 24,
      'cityID': 1634,
      'title': '泸州市',
      'prefix': '0830',
      'pinYin': 'zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1635,
      'title': '德阳市',
      'prefix': '0838',
      'pinYin': 'de yang shi'
    }, {
      'provinceID': 24,
      'cityID': 1636,
      'title': '绵阳市',
      'prefix': '0816',
      'pinYin': 'mian yang shi'
    }, {
      'provinceID': 24,
      'cityID': 1637,
      'title': '广元市',
      'prefix': '0839',
      'pinYin': 'guang yuan shi'
    }, {
      'provinceID': 24,
      'cityID': 1638,
      'title': '遂宁市',
      'prefix': '0825',
      'pinYin': 'sui ning shi'
    }, {
      'provinceID': 24,
      'cityID': 1639,
      'title': '内江市',
      'prefix': '0832',
      'pinYin': 'nei jiang shi'
    }, {
      'provinceID': 24,
      'cityID': 1640,
      'title': '乐山市',
      'prefix': '0833',
      'pinYin': 'le shan shi'
    }, {
      'provinceID': 24,
      'cityID': 1641,
      'title': '南充市',
      'prefix': '0817',
      'pinYin': 'nan chong shi'
    }, {
      'provinceID': 24,
      'cityID': 1642,
      'title': '宜宾市',
      'prefix': '0831',
      'pinYin': 'yi bin shi'
    }, {
      'provinceID': 24,
      'cityID': 1643,
      'title': '广安市',
      'prefix': '0826',
      'pinYin': 'guang an shi'
    }, {
      'provinceID': 24,
      'cityID': 1651,
      'title': '巴中市',
      'prefix': '0827',
      'pinYin': 'ba zhong shi'
    }, {
      'provinceID': 24,
      'cityID': 1652,
      'title': '雅安市',
      'prefix': '0835',
      'pinYin': 'ya an shi'
    }, {
      'provinceID': 24,
      'cityID': 1653,
      'title': '眉山市',
      'prefix': '0833',
      'pinYin': 'mei shan shi'
    }, {
      'provinceID': 24,
      'cityID': 1654,
      'title': '阿坝藏族羌族自治州',
      'prefix': '0837',
      'pinYin': 'a ba cang zu qiang zu zi zhi zhou'
    }, {
      'provinceID': 24,
      'cityID': 1655,
      'title': '甘孜藏族自治州',
      'prefix': '0836',
      'pinYin': 'gan zi cang zu zi zhi zhou'
    }, {
      'provinceID': 24,
      'cityID': 1656,
      'title': '凉山彝族自治州',
      'prefix': '0834',
      'pinYin': 'liang shan yi zu zi zhi zhou'
    }, {
      'provinceID': 24,
      'cityID': 2489,
      'title': '资阳市',
      'prefix': '0832',
      'pinYin': 'zi yang shi'
    }, {
      'provinceID': 24,
      'cityID': 2645,
      'title': '达州市',
      'prefix': '0818',
      'pinYin': 'da zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1644,
      'title': '广汉市',
      'prefix': '0838',
      'pinYin': 'guang han shi'
    }, {
      'provinceID': 24,
      'cityID': 1645,
      'title': '西昌市',
      'prefix': '0834',
      'pinYin': 'xi chang shi'
    }, {
      'provinceID': 24,
      'cityID': 1646,
      'title': '江油市',
      'prefix': '0816',
      'pinYin': 'jiang you shi'
    }, {
      'provinceID': 24,
      'cityID': 1647,
      'title': '彭州市',
      'prefix': '028',
      'pinYin': 'peng zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1648,
      'title': '崇州市',
      'prefix': '028',
      'pinYin': 'chong zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1649,
      'title': '都江堰市',
      'prefix': '028',
      'pinYin': 'du jiang yan shi'
    }, {
      'provinceID': 24,
      'cityID': 2452,
      'title': '邛崃市',
      'prefix': '028',
      'pinYin': 'qiong lai shi'
    }, {
      'provinceID': 24,
      'cityID': 2459,
      'title': '峨眉山市',
      'prefix': '0833',
      'pinYin': 'e mei shan shi'
    }, {
      'provinceID': 24,
      'cityID': 2467,
      'title': '简阳市',
      'prefix': '0832',
      'pinYin': 'jian yang shi'
    }, {
      'provinceID': 24,
      'cityID': 2472,
      'title': '绵竹市',
      'prefix': '0838',
      'pinYin': 'mian zhu shi'
    }, {
      'provinceID': 24,
      'cityID': 2473,
      'title': '什邡市',
      'prefix': '0838',
      'pinYin': 'shi fang shi'
    }, {
      'provinceID': 24,
      'cityID': 2646,
      'title': '阆中市',
      'prefix': '0817',
      'pinYin': 'lang zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 2647,
      'title': '华蓥市',
      'prefix': '0826',
      'pinYin': 'hua ying shi'
    }, {
      'provinceID': 24,
      'cityID': 2648,
      'title': '万源市',
      'prefix': '0818',
      'pinYin': 'wan yuan shi'
    }, {
      'provinceID': 25,
      'cityID': 1659,
      'title': '昆明市',
      'prefix': '0871',
      'pinYin': 'kun ming shi'
    }, {
      'provinceID': 25,
      'cityID': 1661,
      'title': '昭通市',
      'prefix': '0870',
      'pinYin': 'zhao tong shi'
    }, {
      'provinceID': 25,
      'cityID': 1662,
      'title': '曲靖市',
      'prefix': '0874',
      'pinYin': 'qu jing shi'
    }, {
      'provinceID': 25,
      'cityID': 1663,
      'title': '玉溪市',
      'prefix': '0877',
      'pinYin': 'yu xi shi'
    }, {
      'provinceID': 25,
      'cityID': 1664,
      'title': '保山市',
      'prefix': '0875',
      'pinYin': 'bao shan shi'
    }, {
      'provinceID': 25,
      'cityID': 1706,
      'title': '普洱市',
      'prefix': '0879',
      'pinYin': 'pu er shi'
    }, {
      'provinceID': 25,
      'cityID': 1714,
      'title': '临沧市',
      'prefix': '0883',
      'pinYin': 'lin cang shi'
    }, {
      'provinceID': 25,
      'cityID': 1728,
      'title': '丽江市',
      'prefix': '0888',
      'pinYin': 'li jiang shi'
    }, {
      'provinceID': 25,
      'cityID': 2670,
      'title': '西双版纳傣族自治州',
      'prefix': '0691',
      'pinYin': 'xi shuang ban na dai zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2671,
      'title': '德宏傣族景颇族自治州',
      'prefix': '0692',
      'pinYin': 'de hong dai zu jing po zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2672,
      'title': '怒江傈僳族自治州',
      'prefix': '0886',
      'pinYin': 'nu jiang li su zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2673,
      'title': '迪庆藏族自治州',
      'prefix': '0887',
      'pinYin': 'di qing zang zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2674,
      'title': '文山壮族苗族自治州',
      'prefix': '0876',
      'pinYin': 'wen shan zhuang zu miao zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2675,
      'title': '红河哈尼族彝族自治州',
      'prefix': '0873',
      'pinYin': 'hong he ha ni zu yi zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2676,
      'title': '楚雄彝族自治州',
      'prefix': '0878',
      'pinYin': 'zhu xiong yi zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2677,
      'title': '大理白族自治州',
      'prefix': '0872',
      'pinYin': 'da li bai zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 1665,
      'title': '个旧市',
      'prefix': '0873',
      'pinYin': 'ge jiu shi'
    }, {
      'provinceID': 25,
      'cityID': 1666,
      'title': '开远市',
      'prefix': '0873',
      'pinYin': 'kai yuan shi'
    }, {
      'provinceID': 25,
      'cityID': 1667,
      'title': '楚雄市',
      'prefix': '0878',
      'pinYin': 'chu xiong shi'
    }, {
      'provinceID': 25,
      'cityID': 1668,
      'title': '大理市',
      'prefix': '0872',
      'pinYin': 'da li shi'
    }, {
      'provinceID': 25,
      'cityID': 1675,
      'title': '安宁市',
      'prefix': '0871',
      'pinYin': 'an ning shi'
    }, {
      'provinceID': 25,
      'cityID': 1688,
      'title': '宣威市',
      'prefix': '0874',
      'pinYin': 'xuan wei shi'
    }, {
      'provinceID': 25,
      'cityID': 1749,
      'title': '景洪市',
      'prefix': '0691',
      'pinYin': 'jing hong shi'
    }, {
      'provinceID': 25,
      'cityID': 1772,
      'title': '潞西市',
      'prefix': '0692',
      'pinYin': 'lu xi shi'
    }, {
      'provinceID': 25,
      'cityID': 1775,
      'title': '瑞丽市',
      'prefix': '0692',
      'pinYin': 'rui li shi'
    }, {
      'provinceID': 26,
      'cityID': 1785,
      'title': '西安市',
      'prefix': '029',
      'pinYin': 'xi an shi'
    }, {
      'provinceID': 26,
      'cityID': 1787,
      'title': '宝鸡市',
      'prefix': '0917',
      'pinYin': 'bao ji shi'
    }, {
      'provinceID': 26,
      'cityID': 1788,
      'title': '咸阳市',
      'prefix': '029',
      'pinYin': 'xian yang shi'
    }, {
      'provinceID': 26,
      'cityID': 1789,
      'title': '榆林市',
      'prefix': '0912',
      'pinYin': 'yu lin shi'
    }, {
      'provinceID': 26,
      'cityID': 1790,
      'title': '延安市',
      'prefix': '0911',
      'pinYin': 'yan an shi'
    }, {
      'provinceID': 26,
      'cityID': 1791,
      'title': '渭南市',
      'prefix': '0913',
      'pinYin': 'wei nan shi'
    }, {
      'provinceID': 26,
      'cityID': 1795,
      'title': '安康市',
      'prefix': '0915',
      'pinYin': 'an kang shi'
    }, {
      'provinceID': 26,
      'cityID': 1796,
      'title': '汉中市',
      'prefix': '0916',
      'pinYin': 'han zhong shi'
    }, {
      'provinceID': 26,
      'cityID': 2505,
      'title': '铜川市',
      'prefix': '0919',
      'pinYin': 'tong chuan shi'
    }, {
      'provinceID': 26,
      'cityID': 2644,
      'title': '商洛市',
      'prefix': '0914',
      'pinYin': 'shang luo shi'
    }, {
      'provinceID': 26,
      'cityID': 1792,
      'title': '韩城市',
      'prefix': '0913',
      'pinYin': 'han cheng shi'
    }, {
      'provinceID': 26,
      'cityID': 1793,
      'title': '华阴市',
      'prefix': '0913',
      'pinYin': 'hua yin shi'
    }, {
      'provinceID': 26,
      'cityID': 1820,
      'title': '兴平市',
      'prefix': '029',
      'pinYin': 'xing ping shi'
    }, {
      'provinceID': 27,
      'cityID': 1882,
      'title': '兰州市',
      'prefix': '0931',
      'pinYin': 'lan zhou shi'
    }, {
      'provinceID': 27,
      'cityID': 1883,
      'title': '金昌市',
      'prefix': '0935',
      'pinYin': 'jin chang shi'
    }, {
      'provinceID': 27,
      'cityID': 1884,
      'title': '白银市',
      'prefix': '0943',
      'pinYin': 'bai yin shi'
    }, {
      'provinceID': 27,
      'cityID': 1885,
      'title': '天水市',
      'prefix': '0938',
      'pinYin': 'tian shui shi'
    }, {
      'provinceID': 27,
      'cityID': 1886,
      'title': '嘉峪关市',
      'prefix': '0937',
      'pinYin': 'jia yu guan shi'
    }, {
      'provinceID': 27,
      'cityID': 1887,
      'title': '平凉市',
      'prefix': '0933',
      'pinYin': 'ping liang shi'
    }, {
      'provinceID': 27,
      'cityID': 1889,
      'title': '武威市',
      'prefix': '0935',
      'pinYin': 'wu wei shi'
    }, {
      'provinceID': 27,
      'cityID': 1890,
      'title': '张掖市',
      'prefix': '0936',
      'pinYin': 'zhang ye shi'
    }, {
      'provinceID': 27,
      'cityID': 1892,
      'title': '酒泉市',
      'prefix': '0937',
      'pinYin': 'jiu quan shi'
    }, {
      'provinceID': 27,
      'cityID': 1907,
      'title': '定西市',
      'prefix': '0932',
      'pinYin': 'ding xi shi'
    }, {
      'provinceID': 27,
      'cityID': 1920,
      'title': '庆阳市',
      'prefix': '0934',
      'pinYin': 'qing yang shi'
    }, {
      'provinceID': 27,
      'cityID': 2603,
      'title': '陇南市',
      'prefix': '0939',
      'pinYin': 'long nan shi'
    }, {
      'provinceID': 27,
      'cityID': 2604,
      'title': '临夏回族自治州',
      'prefix': '0930',
      'pinYin': 'lin xia hui zuo zi zhi zhou'
    }, {
      'provinceID': 27,
      'cityID': 2605,
      'title': '甘南藏族自治州',
      'prefix': '0941',
      'pinYin': 'gan nan zang zu zi zhi zhou'
    }, {
      'provinceID': 27,
      'cityID': 1891,
      'title': '玉门市',
      'prefix': '0937',
      'pinYin': 'yu men shi'
    }, {
      'provinceID': 27,
      'cityID': 1894,
      'title': '临夏市',
      'prefix': '0930',
      'pinYin': 'lin xia shi'
    }, {
      'provinceID': 27,
      'cityID': 2606,
      'title': '合作市',
      'prefix': '0941',
      'pinYin': 'he zuo shi'
    }, {
      'provinceID': 28,
      'cityID': 1964,
      'title': '银川市',
      'prefix': '0951',
      'pinYin': 'yin chuan shi'
    }, {
      'provinceID': 28,
      'cityID': 1965,
      'title': '石嘴山市',
      'prefix': '0952',
      'pinYin': 'shi zui shan shi'
    }, {
      'provinceID': 28,
      'cityID': 1966,
      'title': '吴忠市',
      'prefix': '0953',
      'pinYin': 'wu zhong shi'
    }, {
      'provinceID': 28,
      'cityID': 1978,
      'title': '固原市',
      'prefix': '0954',
      'pinYin': 'gu yuan shi'
    }, {
      'provinceID': 28,
      'cityID': 1967,
      'title': '青铜峡市',
      'prefix': '0953',
      'pinYin': 'qing tong xia shi'
    }, {
      'provinceID': 28,
      'cityID': 1975,
      'title': '灵武市',
      'prefix': '0951',
      'pinYin': 'ling wu shi'
    }, {
      'provinceID': 28,
      'cityID': 1976,
      'title': '中卫市',
      'prefix': '0955',
      'pinYin': 'zhong wei shi'
    }, {
      'provinceID': 29,
      'cityID': 1984,
      'title': '西宁市',
      'prefix': '0971',
      'pinYin': 'xi ning shi'
    }, {
      'provinceID': 29,
      'cityID': 1988,
      'title': '海东地区',
      'prefix': '0972',
      'pinYin': 'hai dong di qu'
    }, {
      'provinceID': 29,
      'cityID': 2636,
      'title': '海北藏族自治州',
      'prefix': '0970',
      'pinYin': 'hai bei zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2637,
      'title': '黄南藏族自治州',
      'prefix': '0973',
      'pinYin': 'huang nan zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2638,
      'title': '海南藏族自治州',
      'prefix': '0974',
      'pinYin': 'hai nan zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2639,
      'title': '果洛藏族自治州',
      'prefix': '0975',
      'pinYin': 'guo luo zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2640,
      'title': '玉树藏族自治州',
      'prefix': '0976',
      'pinYin': 'yu shu zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2641,
      'title': '海西蒙古族藏族自治州',
      'prefix': '0979',
      'pinYin': 'hai xi meng gu zu zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 1985,
      'title': '格尔木市',
      'prefix': '0979',
      'pinYin': 'ge er mu shi'
    }, {
      'provinceID': 29,
      'cityID': 1986,
      'title': '德令哈市',
      'prefix': '0979',
      'pinYin': 'de ling ha shi'
    }, {
      'provinceID': 29,
      'cityID': 2642,
      'title': '冷湖行委',
      'prefix': '0977',
      'pinYin': 'leng hu xing wei'
    }, {
      'provinceID': 30,
      'cityID': 2026,
      'title': '乌鲁木齐市',
      'prefix': '0991',
      'pinYin': 'wu lu mu qi shi'
    }, {
      'provinceID': 30,
      'cityID': 2027,
      'title': '克拉玛依市',
      'prefix': '0990',
      'pinYin': 'ke la ma yi shi'
    }, {
      'provinceID': 30,
      'cityID': 2028,
      'title': '石河子市',
      'prefix': '0993',
      'pinYin': 'shi he zi shi'
    }, {
      'provinceID': 30,
      'cityID': 2520,
      'title': '五家渠市',
      'prefix': '0994',
      'pinYin': 'wu jia qu shi'
    }, {
      'provinceID': 30,
      'cityID': 2525,
      'title': '阿拉尔市',
      'prefix': '0997',
      'pinYin': 'a la er shi'
    }, {
      'provinceID': 30,
      'cityID': 2655,
      'title': '博尔塔拉蒙古自治州',
      'prefix': '0909',
      'pinYin': 'bo er ta la meng gu zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2656,
      'title': '巴音郭楞蒙古自治州',
      'prefix': '0996',
      'pinYin': 'ba yin guo leng meng gu zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2657,
      'title': '克孜勒苏柯尔克孜自治州',
      'prefix': '0908',
      'pinYin': 'ke zi le su ke er ke zi zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2658,
      'title': '伊犁哈萨克自治州',
      'prefix': '0999',
      'pinYin': 'yi li ha sa ke zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2659,
      'title': '图木舒克市',
      'prefix': '0998',
      'pinYin': 'tu mu shu ke shi'
    }, {
      'provinceID': 30,
      'cityID': 2660,
      'title': '吐鲁番地区',
      'prefix': '0995',
      'pinYin': 'tu lu fan di qu'
    }, {
      'provinceID': 30,
      'cityID': 2661,
      'title': '哈密地区',
      'prefix': '0902',
      'pinYin': 'ha mi di qu'
    }, {
      'provinceID': 30,
      'cityID': 2662,
      'title': '和田地区',
      'prefix': '0903',
      'pinYin': 'he tian di qu'
    }, {
      'provinceID': 30,
      'cityID': 2663,
      'title': '阿克苏地区',
      'prefix': '0997',
      'pinYin': 'a ke su di qu'
    }, {
      'provinceID': 30,
      'cityID': 2664,
      'title': '喀什地区',
      'prefix': '0998',
      'pinYin': 'ka shi di qu '
    }, {
      'provinceID': 30,
      'cityID': 2665,
      'title': '昌吉回族自治州',
      'prefix': '0994',
      'pinYin': 'chang ji hui zu zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2666,
      'title': '塔城地区',
      'prefix': '0901',
      'pinYin': 'ta cheng di qu'
    }, {
      'provinceID': 30,
      'cityID': 2667,
      'title': '阿勒泰地区',
      'prefix': '0906',
      'pinYin': 'a le tai di qu'
    }, {
      'provinceID': 30,
      'cityID': 2668,
      'title': '吐鲁番地区',
      'prefix': '0995',
      'pinYin': 'tu lu fan di qu'
    }, {
      'provinceID': 30,
      'cityID': 2029,
      'title': '吐鲁番市',
      'prefix': '0995',
      'pinYin': 'tu lu fan shi'
    }, {
      'provinceID': 30,
      'cityID': 2030,
      'title': '哈密市',
      'prefix': '0902',
      'pinYin': 'ha mi shi'
    }, {
      'provinceID': 30,
      'cityID': 2031,
      'title': '和田市',
      'prefix': '0903',
      'pinYin': 'he tian shi'
    }, {
      'provinceID': 30,
      'cityID': 2032,
      'title': '阿克苏市',
      'prefix': '0997',
      'pinYin': 'a ke su shi'
    }, {
      'provinceID': 30,
      'cityID': 2033,
      'title': '喀什市',
      'prefix': '0998',
      'pinYin': 'ka shi shi'
    }, {
      'provinceID': 30,
      'cityID': 2034,
      'title': '阿图什市',
      'prefix': '0908',
      'pinYin': 'a tu shi shi'
    }, {
      'provinceID': 30,
      'cityID': 2035,
      'title': '库尔勒市',
      'prefix': '0996',
      'pinYin': 'ku er le shi'
    }, {
      'provinceID': 30,
      'cityID': 2036,
      'title': '昌吉市',
      'prefix': '0994',
      'pinYin': 'chang ji shi'
    }, {
      'provinceID': 30,
      'cityID': 2037,
      'title': '博乐市',
      'prefix': '0909',
      'pinYin': 'bo le shi'
    }, {
      'provinceID': 30,
      'cityID': 2039,
      'title': '伊宁市',
      'prefix': '0999',
      'pinYin': 'yi ning shi'
    }, {
      'provinceID': 30,
      'cityID': 2040,
      'title': '塔城市',
      'prefix': '0901',
      'pinYin': 'ta cheng shi'
    }, {
      'provinceID': 30,
      'cityID': 2041,
      'title': '阿勒泰市',
      'prefix': '0906',
      'pinYin': 'a le tai shi'
    }, {
      'provinceID': 30,
      'cityID': 2085,
      'title': '阜康市',
      'prefix': '0994',
      'pinYin': 'fu kang shi'
    }, {
      'provinceID': 30,
      'cityID': 2104,
      'title': '乌苏市',
      'prefix': '0992',
      'pinYin': 'wu su shi'
    }, {
      'provinceID': 30,
      'cityID': 2519,
      'title': '奎屯市',
      'prefix': '0992',
      'pinYin': 'kui tun shi'
    }, {
      'provinceID': 30,
      'cityID': 2669,
      'title': '博乐市',
      'prefix': '0909',
      'pinYin': 'bu le shi'
    }, {
      'provinceID': 31,
      'cityID': 2114,
      'title': '拉萨市',
      'prefix': '0891',
      'pinYin': 'la sa shi'
    }, {
      'provinceID': 31,
      'cityID': 2527,
      'title': '山南地区',
      'prefix': '0893',
      'pinYin': 'shan nan di qu'
    }, {
      'provinceID': 31,
      'cityID': 2649,
      'title': '阿里地区',
      'prefix': '0897',
      'pinYin': 'a li di qu'
    }, {
      'provinceID': 31,
      'cityID': 2650,
      'title': '林芝地区',
      'prefix': '0894',
      'pinYin': 'li zhi di qu'
    }, {
      'provinceID': 31,
      'cityID': 2651,
      'title': '山南地区',
      'prefix': '',
      'pinYin': 'shan nan di qu'
    }, {
      'provinceID': 31,
      'cityID': 2652,
      'title': '日喀则地区',
      'prefix': '0892',
      'pinYin': 'ri ka ze di qu'
    }, {
      'provinceID': 31,
      'cityID': 2653,
      'title': '那曲地区',
      'prefix': '0896',
      'pinYin': 'na qu di qu'
    }, {
      'provinceID': 31,
      'cityID': 2654,
      'title': '昌都地区',
      'prefix': '0895',
      'pinYin': 'chang du di qu'
    }, {
      'provinceID': 31,
      'cityID': 2115,
      'title': '日喀则市',
      'prefix': '0892',
      'pinYin': 'ri ka ze shi'
    }, {
      'provinceID': 31,
      'cityID': 2123,
      'title': '那曲县',
      'prefix': '0896',
      'pinYin': 'na qu xian'
    }, {
      'provinceID': 31,
      'cityID': 2133,
      'title': '昌都县',
      'prefix': '0895',
      'pinYin': 'chang du xian'
    }, {
      'provinceID': 31,
      'cityID': 2186,
      'title': '林芝县',
      'prefix': '0894',
      'pinYin': 'lin zhi xian'
    }, {
      'provinceID': 32,
      'cityID': 2530,
      'title': '香港地区',
      'prefix': '0852',
      'pinYin': 'xiang gang di qu'
    }, {
      'provinceID': 33,
      'cityID': 2531,
      'title': '澳门地区',
      'prefix': '0853',
      'pinYin': 'ao men di qu'
    }, {
      'provinceID': 34,
      'cityID': 2532,
      'title': '台湾全省',
      'prefix': '0886',
      'pinYin': 'tai wan quan sheng'
    }];
    return citys;
  }

};
module.exports = region;


// WEBPACK FOOTER //
// ./src/scripts/components/contactForm/region.js